/*
ABOUT >>
THIS FILE HAVE MULIPLE DYNAMIC INPUTS FOR MORE MAIN SECTION
FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE 
*/


import React ,{useState ,useLayoutEffect, useEffect,useMemo, useRef} from 'react';
import AddNewDialog from './addNew-popup-list-v-6';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { TextBoxComponent ,NumericTextBoxComponent} from '@syncfusion/ej2-react-inputs';
import moment from 'moment';
import ReactDOM from 'react-dom';

import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import DropdownService from './api.service-v-6';
import './dynamic-v-6.scss';
import {
  CheckBoxComponent,
  ButtonComponent,
} from "@syncfusion/ej2-react-buttons";

// const DynamicDropDownInput = (props) => {
//   console.log(props)
//   const [loading, setLoading] = useState(false);
//   const [dataSourceState, setDataSourceState] = useState(props.dataSource.type == 'Data' ? props.dataSource?.data : []);
//   const [dropdownID, setDropdownID] = useState(props.value.id ? props.value.id : undefined);
//   const [dropdownValue, setDropdownValue] = useState(props.value.value ?props.value.value : '');
//   const [addNew, setAddNew] = useState(props.addNew ? props.addNew : {});
  
//   const [addNewClicked, setAddNewClicked] = useState(false);
//   const [allowThisUseEffect, setAllowThisUseEffect] = useState(false);

//   useEffect(() => {
//     console.log(props)
//     if(allowThisUseEffect == true){
//     setTimeout(()=>{

//       setDropdownValue(props.value.value)
//       setDropdownID(props.value.id)
//     },1000)
//   }
//   }, [props.value.value]);
//   const refs = useRef({});

//   // Assign a dynamic ref based on the name prop
//   if (!refs.current[props.name.value]) {
//     refs.current[props.name.value] = React.createRef();
//   }
//   const dynamicRef = refs.current[props.name.value];
//   console.log(dynamicRef)
//   const ddlFields: object = { value: 'value' };

//   useEffect(() => {
//     if(props.dataSource.type == 'Route' ){
//       console.log(props.dataSource.type);
//       console.log(props.dataSource.route);
//       getDropdownService(props.dataSource.route)
//       setTimeout(()=>setAllowThisUseEffect(true),300)
//     }
    
    
//   }, [props.dataSource?.route]);

//   useEffect(() => {
//     console.log(props.dataSource?.data)
//     if(props.dataSource?.type == 'Data' ){
//       setDataSourceState(props.dataSource.data);
//       // dynamicRef.current.dataSour/ce = props.dataSource.data
//       if(props.isAdd == true){
//         if( props.value.id == 0 || props?.value?.id ){
        
//         let filterData = props.dataSource.data.filter(res=> res.id == props.value.id)
//         console.log(filterData)
//         if(filterData.length > 0){
//         setDropdownID(filterData[0].id)
//         setDropdownValue(filterData[0].value)
//         setTimeout(()=>setAllowThisUseEffect(true),300)
//         }
//       }
//       }
//     }
    
    
//   }, [props.dataSource?.data]);

//   const getDropdownService = async (type) => {
//     try {
//       setLoading(false)
//       const response = await DropdownService.getAllForList(type);
//       if (response.data || response.data.recordset) {
//               setLoading(false)
//               setDataSourceState(response.data.recordset);
//               if(props.isAdd == true && props.value.id != 'undefined' && props.value.id != ''  && props.value.id != null){
//                 let filterData = response.data.recordset.filter(res=>res.id == props.value.id)
//                 console.log(filterData)
//                 setDropdownID(filterData[0].id)
//                 setDropdownValue(filterData[0].value)
//               }
//        } else {
//         setLoading(false)
//         console.error("Invalid response structure:", response);
//         setDataSourceState([])
//       }
//      } catch (error) {
//       setLoading(false)
      
//       setDataSourceState([])
//     }
//   };


//   const handleInputFocus = (inputRef) => {if (inputRef ) {inputRef.current.showPopup();}};

//   const handleChange = (e) =>{
//     setDropdownID(e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined)
//     setDropdownValue(e?.itemData?.value ? e?.itemData?.value : '')
//     if(e?.itemData?.id  || e?.itemData?.id == 0  ){
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name.value]: {...prevValues[props.name.value] ,value :{...e,id:e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
//     }));
//   }else{
//       props.setInputProps((prevValues) => ({
//         ...prevValues,
//         [props.name.value]: {...prevValues[props.name.value] ,value :{...e,id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
//       }));

//     }
//   }

//   // const handleAddNewBlur = (id, ref, value, elementId, productArray, isHaveAddNew) => {
//   //   if ( ref.current.value == null || ref.current.value === '' || id === undefined || id === null) {
//   //     if (value !== '' ) {
//   //       const isValueInProductDesc = productArray.some((e) => e.value === value);
//   //       if (!isValueInProductDesc) {
//   //         ref.current.element.focus();
//   //         ref.current.element.select();
//   //         console.log(ref.current.element)
//   //         // const elem = document.getElementById(elementId).parentElement.parentElement.firstChild;
//   //         const elem = ref.current.element.parentElement.parentElement.firstChild;
//   //         elem.style.border = '3px solid red';
//   //         setTimeout(() => {
//   //           elem.style.border = '1px solid #c8c8c8';
//   //         }, 1000);
//   //       }
//   //     }
//   //     if (!isHaveAddNew) {
//   //       ref.current.element.focus();
//   //     }
//   //   }
//   // };
//   const handleAddNewBlur = (
//   id,
//   ref,
//   value,
//   elementId,
//   productArray,
//   isHaveAddNew,
//   isControlBlur
// ) => {
//   const isBlank = ref.current.value == null || ref.current.value === '';
//   const isIdMissing = id === undefined || id === null;

//   if (isControlBlur) {
//     // Strict validation: don't allow blank, and check ID against value
//     if (isBlank || isIdMissing) {
//       if (value !== '') {
//         const isValueInProductDesc = productArray.some((e) => e.value === value);
//         if (!isValueInProductDesc) {
//           ref.current.element.focus();
//           ref.current.element.select();

//           const elem = ref.current.element.parentElement?.parentElement?.firstChild;
//           if (elem) {
//             elem.style.border = '3px solid red';
//             setTimeout(() => {
//               elem.style.border = '1px solid #c8c8c8';
//             }, 1000);
//           }
//         }
//       }

//       if (!isHaveAddNew) {
//         ref.current.element.focus();
//       }
//     }
//   } else {
//     // Lenient mode: allow blank, but still validate if value is not blank
//     if (value !== '') {
//       const isValueInProductDesc = productArray.some((e) => e.value === value);
//       if (!isValueInProductDesc) {
//         ref.current.element.focus();
//         ref.current.element.select();

//         const elem = ref.current.element.parentElement?.parentElement?.firstChild;
//         if (elem) {
//           elem.style.border = '3px solid red';
//           setTimeout(() => {
//             elem.style.border = '1px solid #c8c8c8';
//           }, 1000);
//         }
//       }
//     }
//   }
// };


//   const onClosing = (e)=>{
// console.log(e);
// getDropdownService(props.dataSource.route)
// const dynamicRef = refs.current[e];

// console.log(dynamicRef.current)

// dynamicRef.current.element.focus()

//   }





//   const itemTemplate = (data ,fields) => {
//     // <td className="template-cell">{data.id}</td>
//     // <td className="template-cell" style={{ textAlign: 'right' }}>{data.value}</td>
//     console.log(fields)
//     return (
      
          
//             <tr className="template-row" key={data.id}>
//               {
//                 fields.map((res ,key)=>{
//                   return(
//             <td className={`template-cell column-${res.field}-${key}`} style={{ textAlign: res.textAlign }}>
//               { res.hasOwnProperty('type') ? 
//               res.type ==  'date' ?  moment(data[res.field]).format(res.format) : res.type ==  'number' ?  data[res.field].toLocaleString(undefined, {
//                 minimumFractionDigits: res.format[1],
//                 maximumFractionDigits: res.format[1],
//                 useGrouping: true // adds the comma as a separator
//             }) : data[res.field] 
//             : data[res.field] 
//             }
//               </td>
//               )
//                 })
//               }
//             </tr>          
        
//     );
//   };
  
//   // Template for displaying the header
//   // const headerTemplate = (data,fields) => (
//   //   showHeader ?
//   //   <table className="template-container">
//   //     <thead>
//   //       <tr className="template-row">
//   //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Producme</th>
//   //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Bal Qty</th>
//   //       </tr>
//   //     </thead>
//   //   </table>
//   //   : null
//   // );

//   return (
//     loading ? (
//       <div>... Loading {props.name.value ? props.name.value.replace(/([A-Z])/g, ' $1').trim() : ''}</div>
//     ) : (
//       <div onKeyDown={(e)=>{
//         if(e.code == 'Enter'){
//         e.preventDefault()
//         }
//       }}>
//         <AutoCompleteComponent 
//           id={props.name.value} 
//                   cssClass="custom-autocomplete"
//           dataSource={dataSourceState}  
//           placeholder={props.caption ? props.caption : `Select ${props.name.replace(/([A-Z])/g, ' $1').trim()}`}
//           fields={ddlFields}
//           floatLabelType='Auto' 
//           highlight={true}
//           // ={(data)=>{
//           //   return (<span><span className='name'>{data.id}</span><span className='name'>{data.value}</span></span>);
//           // }}
        
//           created={(e)=>(props.onCreated ? props.onCreated(e, props.name.value) : null)}
        
//           focus={(e) =>(             
//             props.onFocus ? props.onFocus(e, props.name.value) : null ,handleInputFocus(dynamicRef))}
        
//           change={(e) => (props.onChange ? props.onChange({
//             ...e,
//             ...e?.itemData,
//               id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
//               value:e?.itemData?.value ? e?.itemData?.value : ''
//           }, props.name.value) : null,handleChange(e))}
        
//           select={(e) => (props.onSelect ? props.onSelect({
//             ...e,
//             ...e?.itemData,
//             id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
//             value:e?.itemData?.value ? e?.itemData?.value : '' 
//         }, props.name.value): null,handleChange(e))}

//         blur={(e) =>(
//           console.log(e),
//           // props?.isControlBlur  == false? null :  handleAddNewBlur(dropdownID,dynamicRef,dropdownValue,props.name.value,dataSourceState,addNewClicked),
//             handleAddNewBlur(dropdownID,dynamicRef,dropdownValue,props.name.value,dataSourceState,addNewClicked,props?.isControlBlur),
          
//             props.onBlur ? props.onBlur({
//               ...e,
//               id:dropdownID,
//               value:dropdownValue,
//               dataSource:dataSourceState
//             }, props.name.value) : null,console.log(dropdownID) )
//           }
//           value={dropdownValue}
//           ref={dynamicRef}
//           // disabled={props?.enabled   == undefined ? false : !props?.enabled}     
//           // disabled={true}     
//           enabled={props?.enabled   == undefined ?  props.isView ? !props.isView : true : props?.enabled}
//           itemTemplate={
//             dataSourceState != undefined && dataSourceState != [] && props?.isMultipleColumn && props.multipleDropDown?.dataSource?.length > 0
//               ? (e) => {
//                   console.log(e);
//                             return (
//                       <table className="template-container">
//                         {/* Render the table header only once */}
//                         {e?.ShowHeader == true &&
//                           props.multipleDropDown.showHeader === true && (
//                             <thead>
//                               <tr className="template-row">
//                                 {props.multipleDropDown.dataSource.map((res, key) => (
//                                   <th
//                                     key={key}
//                                     className={`template-cell column-${res.field}-${key}`}
//                                     style={{
//                                       textAlign: 'center',
//                                       // color: '#5CC95E',
//                                       color: '#EAF2FB',
//                                       ...(res.Size && { fontSize: res.Size }),
//                                     }}
//                                   >
//                                     {res.headerText}
//                                   </th>
//                                 ))}
//                               </tr>
//                             </thead>
//                           )}
//                         <tbody>{itemTemplate(e, props.multipleDropDown.dataSource)}</tbody>
//                       </table>
//                     );
                  
//                   }
//                   : null
//                 }
                
                
                
//                 // RUNNING CODE BELOW ITEMTEMPLATE COMMENT ON 070825
// // itemTemplate={
// //   props?.isMultipleColumn && props.multipleDropDown?.dataSource?.length > 0
// //     ? (e) => {
// //         console.log(e);
// //         if (e?.id) {
// //           return (
// //             <table className="template-container">
// //               {/* Render the table header only once */}
// //               {e.id === dataSourceState[0].id &&
// //                 props.multipleDropDown.showHeader === true && (
// //                   <thead>
// //                     <tr className="template-row">
// //                       {props.multipleDropDown.dataSource.map((res, key) => (
// //                         <th
// //                           key={key}
// //                           className={`template-cell column-${res.field}-${key}`}
// //                           style={{
// //                             textAlign: 'center',
// //                             color: '#5CC95E',
// //                             ...(res.Size && { fontSize: res.Size }),
// //                           }}
// //                         >
// //                           {res.headerText}
// //                         </th>
// //                       ))}
// //                     </tr>
// //                   </thead>
// //                 )}
// //               <tbody>{itemTemplate(e, props.multipleDropDown.dataSource)}</tbody>
// //             </table>
// //           );
// //         } else {
// //           return null;
// //         }
// //       }
// //     : null
// // }


//           // RUNNING CODE BELOW ITEMTEMPLATE COMMENT ON 190725
//         //   itemTemplate={
            
//         //     !props.isMultipleColumn ? null : (e) => {
//         //     console.log(e);
//         //     if(e.id){
              
//         //       return <>
//         //       <table className="template-container">
//         // {/* Render the table header only once */}
       
//         //     { e.id == dataSourceState[0].id && props.multipleDropDown.showHeader == true && props.multipleDropDown.dataSource.length > 0? <thead>
//         //   <tr className="template-row">
//         //       {
//         //         props.multipleDropDown.dataSource.map((res ,key)=>{
//         //           return(
//         //             <th className={`template-cell  column-${res.field}-${key}` }
//         //             style={{ textAlign: 'center', color: '#5CC95E',...(res.Size && { fontSize: res.Size }) ,
                  
//         //           }}>{res.headerText}</th>
//         //           )
//         //         })
//         //       }
//         //     </tr>
//         // </thead>:null
//         //     }
  
//         // {/* Loop over dataList to render rows */}
        
//         //       <tbody>
//         //       {itemTemplate(e , props.multipleDropDown.dataSource)}
//         //       </tbody>
//         //       </table>
//         //       </>
//         //     }else{
//         //       return null

//         //     }
//         //   }
//         //   }

















//           // headerTemplate={(e)=>{
//             // return headerTemplate(e, props.multipleDropDown.dataSource)
            
//           // }}


//           // headerTemplate = {!props.isMultipleColumn 
//           // ? null 
//           // : (e) => {
//           //     console.log(e);
//           //     if (props.multipleDropDown.dataSource && props.multipleDropDown.dataSource.length > 0 && showHeader == true) {
//           //         return headerTemplate(e, props.multipleDropDown.dataSource);
//           //     }
//           //     return null; // return nothing if the dataSource is empty
//           // }}
//                 />
//         <TextBoxComponent
//           className='e-input'
//           type='hidden'
//           name={props.name.id}
//           id={props.name.id}
//           floatLabelType='Auto'
//           value={dropdownID}
//         />
//         {addNew.Route && addNew.Security && props.isView == false?
//         <AddNewDialog 
//         Route={addNew.Route} 
//         Security={addNew.Security} 
//         onClosed={onClosing} 
//         RefName={props.name.value}
//         />
//         :null}
//       </div>
//     )
//   );
// };


const DynamicDropDownInput = (props) => {
  console.log(props)
  const [loading, setLoading] = useState(false);
  const [dataSourceState, setDataSourceState] = useState(props.dataSource.type == 'Data' ? props.dataSource?.data : []);
  const [dropdownID, setDropdownID] = useState(props.value.id ? props.value.id : undefined);
  const [dropdownValue, setDropdownValue] = useState(props.value.value ?props.value.value : '');
  const [addNew, setAddNew] = useState(props.addNew ? props.addNew : {});
  
  const [addNewClicked, setAddNewClicked] = useState(false);
  const [allowThisUseEffect, setAllowThisUseEffect] = useState(false);

  useEffect(() => {
    console.log(props)
    if(allowThisUseEffect == true){
    setTimeout(()=>{

      setDropdownValue(props.value.value)
      setDropdownID(props.value.id)
    },1000)
  }
  }, [props.value.value]);
  const refs = useRef({});

  // Assign a dynamic ref based on the name prop
  if (!refs.current[props.name.value]) {
    refs.current[props.name.value] = React.createRef();
  }
  const dynamicRef = refs.current[props.name.value];
  console.log(dynamicRef)
  const ddlFields = { value: 'value' };

  useEffect(() => {
    if(props.dataSource.type == 'Route' ){
      console.log(props.dataSource.type);
      console.log(props.dataSource.route);
      getDropdownService(props.dataSource.route)
      setTimeout(()=>setAllowThisUseEffect(true),300)
    }
    
    
  }, [props.dataSource?.route]);

  useEffect(() => {
    console.log(props.dataSource?.data)
    if(props.dataSource?.type == 'Data' ){
      setDataSourceState(props.dataSource.data);
      // dynamicRef.current.dataSour/ce = props.dataSource.data
      if(props.isAdd == true){
        if( props.value.id == 0 || props?.value?.id ){
        
        let filterData = props.dataSource.data.filter(res=> res.id == props.value.id)
        console.log(filterData)
        if(filterData.length > 0){
        setDropdownID(filterData[0].id)
        setDropdownValue(filterData[0].value)
        setTimeout(()=>setAllowThisUseEffect(true),300)
        }
      }
      }
    }
    
    
  }, [props.dataSource?.data]);

  const getDropdownService = async (type) => {
    try {
      setLoading(false)
      const response = await DropdownService.getAllForList(type);
      if (response.data || response.data.recordset) {
              setLoading(false)
              setDataSourceState(response.data.recordset);
              if(props.isAdd == true && props.value.id != 'undefined' && props.value.id != ''  && props.value.id != null){
                let filterData = response.data.recordset.filter(res=>res.id == props.value.id)
                console.log(filterData)
                setDropdownID(filterData[0].id)
                setDropdownValue(filterData[0].value)
              }
       } else {
        setLoading(false)
        console.error("Invalid response structure:", response);
        setDataSourceState([])
      }
     } catch (error) {
      setLoading(false)
      
      setDataSourceState([])
    }
  };


  // const handleInputFocus = (inputRef) => {if (inputRef ) {inputRef.current.showPopup();}};
 
  const handleInputFocus = (inputRef) => {
    if (!inputRef?.current) return;
  
    // 🔑 Restore full list ONLY
    inputRef.current.dataSource = [...dataSourceState];
  
    // 🔑 Open popup
    requestAnimationFrame(() => {
      setTimeout(() => {
        
        inputRef.current.showPopup();
      }, 50);
    });
  };
  

  const handleChange = (e) =>{
    setDropdownID(e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined)
    setDropdownValue(e?.itemData?.value ? e?.itemData?.value : '')
    if(e?.itemData?.id  || e?.itemData?.id == 0  ){
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name.value]: {...prevValues[props.name.value] ,value :{...e,id:e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
    }));
  }else{
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name.value]: {...prevValues[props.name.value] ,value :{...e,id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
      }));

    }
  }

  const handleAddNewBlur = (id, ref, value, elementId, productArray, isHaveAddNew) => {
    console.log(id)
    if ( ref.current.value == null || ref.current.value === '' || id === undefined || id === null) {
      if (value !== '') {
        const isValueInProductDesc = productArray.some((e) => e.value === value);
        if (!isValueInProductDesc) {
          ref.current.element.focus();
          ref.current.element.select();
          console.log(ref.current.element)
          // const elem = document.getElementById(elementId).parentElement.parentElement.firstChild;
          const elem = ref.current.element.parentElement.parentElement.firstChild;
          elem.style.border = '3px solid red';
          setTimeout(() => {
            elem.style.border = '1px solid #c8c8c8';
          }, 1000);
        }
      }
      if (!isHaveAddNew) {
        ref.current.element.focus();
      }
    }
  };

  const onClosing = (e)=>{
console.log(e);
getDropdownService(props.dataSource.route)
const dynamicRef = refs.current[e];

console.log(dynamicRef.current)

dynamicRef.current.element.focus()

  }





  const itemTemplate = (data ,fields) => {
    // <td className="template-cell">{data.id}</td>
    // <td className="template-cell" style={{ textAlign: 'right' }}>{data.value}</td>
    console.log(fields)
    return (
      
          
            <tr className="template-ro " key={data.id}>
              {
                fields.map((res ,key)=>{
                  return(
            <td className={`template-cel  column-${res.field}-${key}`} style={{ textAlign: res.textAlign,
                                                 ...(res.Width && { width: res.Width  }),
                                                 ...(res.Size && { fontSize: res.Size })

             }}>
              { res.hasOwnProperty('type') ? 
              res.type ==  'date' ?  moment(data[res.field]).format(res.format) : res.type ==  'number' ?  data[res.field].toLocaleString(undefined, {
                minimumFractionDigits: res.format[1],
                maximumFractionDigits: res.format[1],
                useGrouping: true // adds the comma as a separator
            }) : data[res.field] 
            : data[res.field] 
            }
              </td>
              )
                })
              }
            </tr>          
        
    );
  };
  
  // Template for displaying the header
  // const headerTemplate = (data,fields) => (
  //   showHeader ?
  //   <table className="template-container">
  //     <thead>
  //       <tr className="template-row">
  //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Producme</th>
  //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Bal Qty</th>
  //       </tr>
  //     </thead>
  //   </table>
  //   : null
  // );

  
  const MultiDDHeader = () => (
    <div className="multi-dd-header">
      <table className="template-contain">
        <thead id="show-header-multidd">
          <tr>
            {props.multipleDropDown.dataSource.map((res, key) => (
              <th
                key={key}
                style={{
                  width: res.Width,
                  textAlign: 'center',
                  fontSize: res.Size
                }}
              >
                {res.headerText}
              </th>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
  
  
  const onOpen = () => {
    const popup = document.getElementById(`${props.name.value}_popup`);
    if (!popup || popup.querySelector('.multi-dd-header') || props?.multipleDropDown?.showHeader != true) return;
  
    const headerDiv = document.createElement('div');
    headerDiv.className = 'multi-dd-header';
  
    popup.prepend(headerDiv);
  
    ReactDOM.render(<MultiDDHeader />, headerDiv);
  };
  
  useEffect(() => {
    const ac = dynamicRef.current;
    if (!ac) return;
  
    const inputEl = ac.element;
    if (!inputEl) return;
  
    const handleNativeKeyDown = (e) => {
      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          if (!ac.isPopupOpen) {
            e.preventDefault();
            ac.showPopup();
          }
          break;
  
        // case 'Enter':
        //   if (ac.isPopupOpen) {
        //     e.preventDefault();
        //     const focused = ac.list?.querySelector('.e-item-focus');
        //     focused?.click();
        //     ac.hidePopup();
        //   }
        //   break;
  
        // case 'Escape':
        //   if (ac.isPopupOpen) {
        //     e.preventDefault();
        //     ac.hidePopup();
        //   }
        //   break;
  
        // case 'Tab':
        //   if (ac.isPopupOpen) {
        //     const focusedItem = ac.list?.querySelector('.e-item-focus');
        //     focusedItem?.click();
        //     ac.hidePopup();
        //   }
        //   // allow tab navigation
        //   break;
  
        default:
          break;
      }
    };
  
    inputEl.addEventListener('keydown', handleNativeKeyDown);
  
    return () => {
      inputEl.removeEventListener('keydown', handleNativeKeyDown);
    };
  }, [dataSourceState, dropdownID]);
  

  return (
    loading ? (
      <div>... Loading {props.name.value ? props.name.value.replace(/([A-Z])/g, ' $1').trim() : ''}</div>
    ) : (
      <div onKeyDown={(e)=>{
        if(e.code == 'Enter'){
        e.preventDefault()
        }
      }}>
        <AutoCompleteComponent 
          // filtering={onFiltering}
          // keyUp={(e) => handleKeyDown(e, dynamicRef)}

          id={props.name.value} 
          cssClass={props?.isMultipleColumn ? "multi-custom-autocomplete" :"custom-autocomplete"}
          dataSource={dataSourceState}  
          placeholder={props.caption ? props.caption : `Select ${props.name.replace(/([A-Z])/g, ' $1').trim()}`}
          fields={ddlFields}
          floatLabelType='Auto' 
          highlight={true}
          // ={(data)=>{
          //   return (<span><span className='name'>{data.id}</span><span className='name'>{data.value}</span></span>);
          // }}
        
          created={(e)=>(props.onCreated ? props.onCreated(e, props.name.value) : null)}
        
          focus={(e) =>(             
            props.onFocus ? props.onFocus(e, props.name.value) : null ,handleInputFocus(dynamicRef))}
        
          change={(e) => (props.onChange ? props.onChange({
            ...e,
            ...e?.itemData,
              id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
              value:e?.itemData?.value ? e?.itemData?.value : ''
          }, props.name.value) : null,handleChange(e))}
        
          select={(e) => (props.onSelect ? props.onSelect({
            ...e,
            ...e?.itemData,
            id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
            value:e?.itemData?.value ? e?.itemData?.value : '' 
        }, props.name.value): null,handleChange(e))}

        blur={(e) =>(
          console.log(e),
          props?.isControlBlur  == false? null :  handleAddNewBlur(dropdownID,dynamicRef,dropdownValue,props.name.value,dataSourceState,addNewClicked),
            props.onBlur ? props.onBlur({
              ...e,
              id:dropdownID,
              value:dropdownValue,
              dataSource:dataSourceState
            }, props.name.value) : null,console.log(dropdownID) )
          }
          value={dropdownValue}
          ref={dynamicRef}
          open={onOpen}
          // disabled={props?.enabled   == undefined ? false : !props?.enabled}     
          // disabled={true}     
          enabled={props?.enabled   == undefined ?  props.isView ? !props.isView : true : props?.enabled}
          itemTemplate={
            dataSourceState != undefined && dataSourceState != [] && props?.isMultipleColumn && props.multipleDropDown?.dataSource?.length > 0
              ? (e) => {
                  console.log(e);
                            return (
                      <table className="template-contain">
                        {/* Render the table header only once */}
                        {/* {e?.ShowHeader == true &&
                          props.multipleDropDown.showHeader === true && (
                            <thead>
                              <tr className="template-ro">
                                {props.multipleDropDown.dataSource.map((res, key) => (
                                  <th
                                    key={key}
                                    className={`template-cel header-column-${res.field}-${key}`}
                                    style={{
                                   ...(res.Width && { width: res.Width  }),
                                      textAlign: 'center',
                                      color: '#333',
                                      ...(res.Size && { fontSize: res.Size }),
                                    }}
                                  >
                                    {res.headerText}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                          )} */}
                        <tbody>{itemTemplate(e, props.multipleDropDown.dataSource)}</tbody>
                      </table>
                    );
                  
                  }
                  : null
                }
                
                
                
                // RUNNING CODE BELOW ITEMTEMPLATE COMMENT ON 070825
// itemTemplate={
//   props?.isMultipleColumn && props.multipleDropDown?.dataSource?.length > 0
//     ? (e) => {
//         console.log(e);
//         if (e?.id) {
//           return (
//             <table className="template-container">
//               {/* Render the table header only once */}
//               {e.id === dataSourceState[0].id &&
//                 props.multipleDropDown.showHeader === true && (
//                   <thead>
//                     <tr className="template-row">
//                       {props.multipleDropDown.dataSource.map((res, key) => (
//                         <th
//                           key={key}
//                           className={`template-cell column-${res.field}-${key}`}
//                           style={{
//                             textAlign: 'center',
//                             color: '#5CC95E',
//                             ...(res.Size && { fontSize: res.Size }),
//                           }}
//                         >
//                           {res.headerText}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                 )}
//               <tbody>{itemTemplate(e, props.multipleDropDown.dataSource)}</tbody>
//             </table>
//           );
//         } else {
//           return null;
//         }
//       }
//     : null
// }


          // RUNNING CODE BELOW ITEMTEMPLATE COMMENT ON 190725
        //   itemTemplate={
            
        //     !props.isMultipleColumn ? null : (e) => {
        //     console.log(e);
        //     if(e.id){
              
        //       return <>
        //       <table className="template-container">
        // {/* Render the table header only once */}
       
        //     { e.id == dataSourceState[0].id && props.multipleDropDown.showHeader == true && props.multipleDropDown.dataSource.length > 0? <thead>
        //   <tr className="template-row">
        //       {
        //         props.multipleDropDown.dataSource.map((res ,key)=>{
        //           return(
        //             <th className={`template-cell  column-${res.field}-${key}` }
        //             style={{ textAlign: 'center', color: '#5CC95E',...(res.Size && { fontSize: res.Size }) ,
                  
        //           }}>{res.headerText}</th>
        //           )
        //         })
        //       }
        //     </tr>
        // </thead>:null
        //     }
  
        // {/* Loop over dataList to render rows */}
        
        //       <tbody>
        //       {itemTemplate(e , props.multipleDropDown.dataSource)}
        //       </tbody>
        //       </table>
        //       </>
        //     }else{
        //       return null

        //     }
        //   }
        //   }

















          // headerTemplate={(e)=>{
            // return headerTemplate(e, props.multipleDropDown.dataSource)
            
          // }}


          // headerTemplate = {!props.isMultipleColumn 
          // ? null 
          // : (e) => {
          //     console.log(e);
          //     if (props.multipleDropDown.dataSource && props.multipleDropDown.dataSource.length > 0 && showHeader == true) {
          //         return headerTemplate(e, props.multipleDropDown.dataSource);
          //     }
          //     return null; // return nothing if the dataSource is empty
          // }}
                />
        <TextBoxComponent
          className='e-input'
          type='hidden'
          name={props.name.id}
          id={props.name.id}
          floatLabelType='Auto'
          value={dropdownID}
        />
        {addNew.Route && addNew.Security && props.isView == false?
        <AddNewDialog 
        Route={addNew.Route} 
        Security={addNew.Security} 
        onClosed={onClosing} 
        PopupHeading={addNew?.PopupHeading || ''}
        RefName={props.name.value}
        />
        :null}
      </div>
    )
  );
};



const DynamicDateInput = (props) => {

  useEffect(()=>{
if(props.value == 'currentDate'){
  props.setInputProps((prevValues) => ({
    ...prevValues,
    [props.name]: {...prevValues[props.name] ,value :moment(new Date()).format('DD-MMM-YY')  }
  }));
}else if(props.isAdd == false){
  props.setInputProps((prevValues) => ({
    ...prevValues,
    [props.name]: {...prevValues[props.name] ,value :moment(props.value).format('DD-MMM-YY')  }
  }));

}
  },[])
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value || prevValues[props.name].value}
    }));
  };
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value || prevValues[props.name].value }
    }));
  };

  return (
    <div
    onKeyDown={(e)=>{
      if(e.code == 'Enter'){
      e.preventDefault()
      }
    }}
    >
      <DatePickerComponent
        id={props.name}
        name={props.name}
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        floatLabelType='Auto'
        format='dd-MMM-yy'
        // {
        //   ...(props.min
        //     ? { ...props.min}
        //     : {})
        // }
        min={props?.min}
        max={props?.max}

        created={(e)=>(props.onCreated ? props.onCreated(e, props.name) : null)}
        onBlur={(e)=>(props.onBlur ? props.onBlur(e.target.value, props.name) : null ,handleBlur(e))}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (props.onChange ? props.onChange(e.value, props.name) : null,handleChange(e))}
        value={props.value == 'currentDate'?  new Date() : props.value || ''}
        disabled={props?.enabled   == undefined ?  props.isView ? props.isView : false : !props?.enabled}     
      />
    </div>
  );
};

const DynamicNumericInputs = (props) => {
  console.log(props)
  // const formatNumberWithCommas = (number) => {
  //   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value == "" ? prevValues[props.name].value :  e.value}
    }));
  };
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value == "" ?  parseFloat(0).toFixed(props.decimal || 0)  : parseFloat(e.target.value).toFixed(props.decimal || 0)}
    }));
  };
 
  const handleCreated = (e) => {
    console.log(e);
    // const value = parseFloat(props.value).toFixed(props.decimal || 0) || 0.0;
    const value = props.value || 0.0;
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {
        ...prevValues[props.name],
        value: value,
        // formattedValue: formatNumberWithCommas(value)
      }
    }));
  };
  return (
    <>
      <TextBoxComponent
        className='e-input'
        type='number'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        // placeholder={props.caption ? props.caption :''}
        name={props.name}
      
        id={props.name}
        floatLabelType='Auto'
        value={props.value || 0.0}
        // value={props.formattedV/alue || 0.0}
 
        created={(e)=>(handleCreated(e) , props.onCreated ? props.onCreated(e, props.name) : null )}
        onBlur={(e)=>(handleBlur(e) , props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (handleChange(e) , props.onChange ? props.onChange(e.value, props.name) : null)}
        enabled={props?.enabled == false  ?  props?.enabled :    true}     
        // disabled={!props?.enabled  false}

        />
    </>
  );
};


// const DynamicNumericInput = (props) => {
//   const [inputType, setInputType] = useState('text');

//   const handleChange = (e) => {
//     console.log(e);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: e?.value === "" ? prevValues[props.name].value : e.value
//       }
//     }));
//   };

//   const handleBlur = (e) => {
//     console.log(e);
//     setInputType('text'); // Change back to text on blur
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: e?.target?.value === "" ? parseFloat(0).toFixed(props.decimal || 0) : parseFloat(e.target.value).toFixed(props.decimal || 0)
//       }
//     }));
//   };

//   const handleFocus = (e) => {
//     console.log(e);
//     setInputType('number'); // Change to number on focus
//     if (props.onFocus) {
//       props.onFocus(e, props.name);
//     }
//   };

//   const handleCreated = (e) => {
//     console.log(e);
//     const value = props.value || 0.0;
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value,
//       }
//     }));
//   };

//   return (
//     <>
//       <TextBoxComponent
//         className='e-input'
//         type={inputType}
//         placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//         name={props.name}
//         id={props.name}
//         floatLabelType='Auto'
//         value={inputType == 'text' ?  props.value.toLocaleString() || 0.0 : props.value || 0.0}
//         created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
//         onBlur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
//         onFocus={handleFocus}
//         onChange={(e) => (handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         enabled={props?.enabled === false ? props?.enabled : true}
//       />
//     </>
//   );
// };
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
// backup 012126
// const DynamicNumericInput = (props) => {
//   // Normalize field name (string or {value})
//   const fieldName = useMemo(() => {
//     if (typeof props.name === "string") return props.name;
//     if (props.name && typeof props.name === "object" && typeof props.name.value === "string") return props.name.value;
//     return String(props.name ?? "");
//   }, [props.name]);

//   const decimals = useMemo(() => {
//     const d = typeof props.decimal === "number" ? props.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   }, [props.decimal]);

//   const textBoxRef = useRef(null);
//   const [isFocused, setIsFocused] = useState(false);
//   const [displayValue, setDisplayValue] = useState("");

//   // ------------------------
//   // Helpers
//   // ------------------------
//   const stripFormatting = (val) => {
//     const s = String(val ?? "").trim();
//     // remove commas and spaces
//     return s.replace(/,/g, "").replace(/\s+/g, "");
//   };

//   const toNumberSafe = (val) => {
//     const raw = stripFormatting(val);
//     if (raw === "" || raw === "-" || raw === "." || raw === "-.") return 0;
//     const n = Number(raw);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const roundToDecimals = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (decimals === 0) return Math.round(n);
//     // avoid float artifacts
//     return Number(Number(n).toFixed(decimals));
//   };

//   const toFixedString = (n) => {
//     const r = roundToDecimals(n);
//     return decimals === 0 ? String(Math.round(r)) : Number(r).toFixed(decimals);
//   };

//   const formatForDisplay = (val) => {
//     const n = toNumberSafe(val);
//     const r = roundToDecimals(n);
//     return Number(r).toLocaleString("en-US", {
//       minimumFractionDigits: decimals,
//       maximumFractionDigits: decimals,
//     });
//   };

  
//   const getFieldDecimals = (field) => {
//     const d = typeof field?.decimal === "number" ? field.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   };
  
//   const roundTo = (n, d) => {
//     if (!Number.isFinite(n)) return 0;
//     if (d === 0) return Math.round(n);
//     return Number(Number(n).toFixed(d));
//   };
  
//   const recalcFormulas = (values, changedField) => {
//     const next = { ...values };
  
//     // evaluate in multiple passes to handle dependencies:
//     // e.g. totalValues depends on salesTaxApplicable which depends on valueSalesExcludingST
//     for (let pass = 0; pass < 4; pass++) {
//       let anyChange = false;
  
//       for (const key of Object.keys(next)) {
//         const field = next[key];
//         if (!field || typeof field.formula !== "string") continue;
  
//         // Optimization: first pass only formulas that reference the changed field.
//         // Later passes recompute all formulas to stabilize dependent ones.
//         if (pass === 0 && !field.formula.includes(changedField)) continue;
  
//         const tokens = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
//         const context = {};
  
//         for (const t of tokens) {
//           if (!next[t]) continue;
//           // IMPORTANT: do NOT round tokens here
//           context[t] = toNumberSafe(next[t].value);
//         }
  
//         try {
//           // eslint-disable-next-line no-new-func
//           const result = new Function(
//             ...Object.keys(context),
//             `return (${field.formula});`
//           )(...Object.values(context));
  
//           const outDec = getFieldDecimals(field);
//           const outNum = Number.isFinite(Number(result)) ? Number(result) : 0;
//           const finalNum = roundTo(outNum, outDec);
//           const finalStr = outDec === 0 ? String(Math.round(finalNum)) : finalNum.toFixed(outDec);
  
//           if (String(field.value ?? "") !== finalStr) {
//             next[key] = { ...field, value: finalStr };
//             anyChange = true;
//           }
//         } catch {
//           // ignore formula errors
//         }
//       }
  
//       if (!anyChange) break;
//     }
  
//     return next;
//   };
  

//   // ------------------------
//   // Sync local display with props.value
//   // ------------------------
//   useEffect(() => {
//     // While focused -> show raw (no commas), otherwise show formatted
//     if (isFocused) {
//       setDisplayValue(stripFormatting(props.value));
//     } else {
//       setDisplayValue(formatForDisplay(props.value));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [props.value, isFocused, decimals]);

//   // ------------------------
//   // Commit value to parent state (and recalc formulas)
//   // ------------------------
//   const commitValue = (rawInput) => {
//     const n = toNumberSafe(rawInput);
//     const fixedStr = toFixedString(n);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     return fixedStr;
//   };

//   // ------------------------
//   // Events
//   // ------------------------
//   const getInputEl = () => {
//     const inst = textBoxRef.current;
//     return inst?.inputElement || inst?.element?.querySelector("input");
//   };
  
//   const selectAllNextPaint = () => {
//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         const el = getInputEl();
//         if (!el) return;
//         el.focus();
//         // select() sometimes fails on some browsers if not focused
//         if (typeof el.select === "function") el.select();
//         else el.setSelectionRange?.(0, el.value?.length ?? 0);
//       });
//     });
//   };
  
//   // const handleFocus = (e) => {
//   //   setIsFocused(true);

//   //   // show raw
//   //   setDisplayValue(stripFormatting(props.value));

//   //   // select text after render
//   //   requestAnimationFrame(() => {
//   //     const el = e?.event?.target;
//   //     if (el && typeof el.select === "function") el.select();
//   //   });

//   //   if (props.onFocus) props.onFocus(e, fieldName);
//   // };
//   const handleFocus = (e) => {
//     setIsFocused(true);
//     setDisplayValue(stripFormatting(props.value));
  
//     // select after raw value is rendered
//     selectAllNextPaint();
  
//     props.onFocus?.(e, fieldName);
//   };
  

//   const handleBlur = (e) => {
//     setIsFocused(false);

//     const inputVal = e?.event?.target?.value ?? "";
//     const fixedStr = commitValue(inputVal);

//     // show formatted after commit
//     setDisplayValue(formatForDisplay(fixedStr));

//     if (props.onBlur) props.onBlur(fixedStr, fieldName);
//   };

//   const handleInput = (e) => {
//     // e.value is the textbox value (string)
//     const raw = e?.value ?? "";

//     // Keep what user types in UI while focused
//     setDisplayValue(raw);

//     // Update parent live as unformatted numeric string (comma-safe)
//     // (Do NOT format here; formatting only on blur)
//     const n = toNumberSafe(raw);
//     const liveStr = decimals === 0 ? String(Math.trunc(n)) : stripFormatting(raw);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: liveStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     if (props.onChange) props.onChange(liveStr, fieldName);
//   };

//   const handleCreated = () => {
//     // Initialize if undefined/null
//     const initial = props.value ?? 0;
//     const fixedStr = toFixedString(toNumberSafe(initial));

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return updated;
//     });

//     setDisplayValue(formatForDisplay(fixedStr));

//     if (props.onCreated) props.onCreated(null, fieldName);
//   };

//   const enabled =
//     props?.enabled === false ? false : props.isView ? !props.isView : true;

//   return (
//     <div
//       onKeyDown={(e) => {
//         if (e.code === "Enter") e.preventDefault();
//       }}
//     >
//       <TextBoxComponent
//         className="e-input"
//         ref={textBoxRef}
//         type="text"
//         inputMode="decimal"
//         placeholder={
//           props.caption
//             ? props.caption
//             : fieldName.replace(/([A-Z])/g, " $1").trim()
//         }
//         name={`${fieldName}_display`}
//         id={`${fieldName}_display`}
//         floatLabelType="Auto"
//         value={displayValue}
//         cssClass="no-spin"
//         style={{ textAlign: "right", paddingRight: "8px" }}
//         created={handleCreated}
//         focus={handleFocus}
//         blur={handleBlur}
//         input={handleInput}     // use ONE handler only (avoid double calls)
//         enabled={enabled}
//       />

//       {/* Hidden real value */}
//       <TextBoxComponent name={fieldName} id={fieldName} type="hidden" value={props.value} />
//     </div>
//   );
// };





// 012126 - 02
// const DynamicNumericInput = (props) => {
//   // Normalize field name (string or {value})
//   const fieldName = useMemo(() => {
//     if (typeof props.name === "string") return props.name;
//     if (props.name && typeof props.name === "object" && typeof props.name.value === "string") return props.name.value;
//     return String(props.name ?? "");
//   }, [props.name]);

//   const decimals = useMemo(() => {
//     const d = typeof props.decimal === "number" ? props.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   }, [props.decimal]);

//   // ✅ AllowNagetive option (default true)
//   const allowNegative = useMemo(() => {
//     if (typeof props?.AllowNagetive === "boolean") return props.AllowNagetive;
//     if (typeof props?.allowNegative === "boolean") return props.allowNegative;
//     return true; // default allow negative
//   }, [props?.AllowNagetive, props?.allowNegative]);

//   // ✅ step option for ArrowUp/Down
//   const step = useMemo(() => {
//     const s = Number(props?.step || 1);
//     if (Number.isFinite(s) && s > 0) return s;
//     // default: if decimals -> smallest meaningful step, else 1
//     return decimals > 0 ? 1 / Math.pow(10, decimals) : 1;
//   }, [props?.step, decimals]);

//   const textBoxRef = useRef(null);
//   const [isFocused, setIsFocused] = useState(false);
//   const [displayValue, setDisplayValue] = useState("");

//   // ------------------------
//   // Helpers
//   // ------------------------
//   const stripFormatting = (val) => {
//     const s = String(val ?? "").trim();
//     return s.replace(/,/g, "").replace(/\s+/g, "");
//   };

//   const stripMinusIfNotAllowed = (val) => {
//     const s = String(val ?? "");
//     if (allowNegative) return s;
//     // remove all minus signs
//     return s.replace(/-/g, "");
//   };

//   const toNumberSafe = (val) => {
//     const raw = stripFormatting(val);
//     if (raw === "" || raw === "-" || raw === "." || raw === "-.") return 0;
//     const n = Number(raw);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const sanitizeNumber = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (!allowNegative && n < 0) return 0;
//     return n;
//   };

//   const roundToDecimals = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (decimals === 0) return Math.round(n);
//     return Number(Number(n).toFixed(decimals));
//   };

//   const toFixedString = (n) => {
//     const clean = sanitizeNumber(n);
//     const r = roundToDecimals(clean);
//     return decimals === 0 ? String(Math.round(r)) : Number(r).toFixed(decimals);
//   };

//   const formatForDisplay = (val) => {
//     const n = sanitizeNumber(toNumberSafe(val));
//     const r = roundToDecimals(n);
//     return Number(r).toLocaleString("en-US", {
//       minimumFractionDigits: decimals,
//       maximumFractionDigits: decimals,
//     });
//   };

//   const getFieldDecimals = (field) => {
//     const d = typeof field?.decimal === "number" ? field.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   };

//   const roundTo = (n, d) => {
//     if (!Number.isFinite(n)) return 0;
//     if (d === 0) return Math.round(n);
//     return Number(Number(n).toFixed(d));
//   };

//   const recalcFormulas = (values, changedField) => {
//     const next = { ...values };

//     for (let pass = 0; pass < 4; pass++) {
//       let anyChange = false;

//       for (const key of Object.keys(next)) {
//         const field = next[key];
//         if (!field || typeof field.formula !== "string") continue;

//         if (pass === 0 && !field.formula.includes(changedField)) continue;

//         const tokens = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
//         const context = {};

//         for (const t of tokens) {
//           if (!next[t]) continue;
//           context[t] = toNumberSafe(next[t].value); // do NOT round tokens here
//         }

//         try {
//           // eslint-disable-next-line no-new-func
//           const result = new Function(...Object.keys(context), `return (${field.formula});`)(
//             ...Object.values(context)
//           );

//           const outDec = getFieldDecimals(field);
//           const outNum = Number.isFinite(Number(result)) ? Number(result) : 0;
//           const finalNum = roundTo(outNum, outDec);
//           const finalStr = outDec === 0 ? String(Math.round(finalNum)) : finalNum.toFixed(outDec);

//           if (String(field.value ?? "") !== finalStr) {
//             next[key] = { ...field, value: finalStr };
//             anyChange = true;
//           }
//         } catch {
//           // ignore formula errors
//         }
//       }

//       if (!anyChange) break;
//     }

//     return next;
//   };

//   // ------------------------
//   // Sync local display with props.value
//   // ------------------------
//   useEffect(() => {
//     if (isFocused) {
//       setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));
//     } else {
//       setDisplayValue(formatForDisplay(props.value));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [props.value, isFocused, decimals, allowNegative]);
//   const isFocusedRef = useRef(false);
//   const selectTokenRef = useRef(0);
  
//   useEffect(() => {
//     isFocusedRef.current = isFocused;
//   }, [isFocused]);
  
//   // ------------------------
//   // Commit value to parent state (and recalc formulas)
//   // ------------------------
//   const commitValue = (rawInput) => {
//     const cleanedRaw = stripMinusIfNotAllowed(rawInput);
//     const n = sanitizeNumber(toNumberSafe(cleanedRaw));
//     const fixedStr = toFixedString(n);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     return fixedStr;
//   };

//   // ------------------------
//   // Get input element
//   // ------------------------
//   const getInputEl = () => {
//     const inst = textBoxRef.current;
//     return inst?.inputElement || inst?.element?.querySelector("input");
//   };

//   // ✅ SUPER reliable select-all on focus/tab
//   const selectAllReliable = () => {
//     const trySelect = () => {
//       const el = getInputEl();
//       console.log(el);
//       if (!el) return false;
//       el.focus();

//       const len = el.value?.length ?? 0;
//       try {
//         // best approach
//         el.setSelectionRange(0, len);
//       } catch {
//         // fallback
//         if (typeof el.select === "function") el.select();
//       }
//       return true;
//     };

//     // attempt multiple times (Syncfusion re-renders can kill selection)
//     trySelect();
//     requestAnimationFrame(() => trySelect());
//     requestAnimationFrame(() => requestAnimationFrame(() => trySelect()));
//     setTimeout(() => trySelect(), 0);
//     setTimeout(() => trySelect(), 40);
//   };
//   const setEJ2InstantValue = (val) => {
//     const inst = textBoxRef.current;
//     const v = String(val ?? "");
  
//     // ✅ Syncfusion instance update (FAST + reliable)
//     if (inst) {
//       inst.value = v;
//       inst.dataBind?.(); // forces DOM update immediately
//     }
  
//     // ✅ fallback: raw DOM update
//     const el = getInputEl();
//     if (el && el.value !== v) el.value = v;
//   };
  

//   const selectAllSticky = () => {
//     const token = ++selectTokenRef.current;
//     const start = performance.now();
//     const maxMs = 700; // enough to beat Syncfusion caret reset
  
//     const tick = () => {
//       // if new focus happened, stop old loop
//       if (selectTokenRef.current !== token) return;
  
//       const el = getInputEl();
//       if (el) {
//         const len = el.value?.length ?? 0;
  
//         try {
//           el.focus();
//           el.setSelectionRange(0, len);
//         } catch {
//           el.select?.();
//         }
//       }
  
//       // keep trying until Syncfusion stops resetting caret
//       if (performance.now() - start < maxMs) {
//         requestAnimationFrame(tick);
//       }
//     };
  
//     requestAnimationFrame(tick);
//   };
  
//   const selectAllHARD = () => {
//     const start = performance.now();
//     const maxMs = 800;
  
//     const attempt = () => {
//       const el = getInputEl();
//       if (!el) {
//         if (performance.now() - start < maxMs) requestAnimationFrame(attempt);
//         return;
//       }
  
//       const len = el.value?.length ?? 0;
//       if (len <= 0) {
//         if (performance.now() - start < maxMs) requestAnimationFrame(attempt);
//         return;
//       }
  
//       try {
//         el.focus();
//         el.setSelectionRange(0, len);
//       } catch {
//         el.select?.();
//       }
  
//       // ✅ Syncfusion may override selection -> keep retrying until it sticks
//       const ok = el.selectionStart === 0 && el.selectionEnd === len;
//       if (!ok && performance.now() - start < maxMs) requestAnimationFrame(attempt);
//     };
  
//     requestAnimationFrame(attempt);
//     setTimeout(() => requestAnimationFrame(attempt), 20);
//     setTimeout(() => requestAnimationFrame(attempt), 60);
//     setTimeout(() => requestAnimationFrame(attempt), 120);
//     setTimeout(() => requestAnimationFrame(attempt), 240);
//     setTimeout(() => requestAnimationFrame(attempt), 400);
//   };
  
//   // ------------------------
//   // Events
//   // ------------------------

//   // const handleFocus = (e) => {
//   //   setIsFocused(true);
  
//   //   const raw = stripMinusIfNotAllowed(stripFormatting(props.value));
  
//   //   // ✅ set state (react)
//   //   setDisplayValue(raw);
  
//   //   // ✅ FORCE Syncfusion input value IMMEDIATELY (no waiting)
//   //   setEJ2InstantValue(raw);
  
//   //   // ✅ Now select (Syncfusion sometimes overwrites -> HARD retry)
//   //   selectAllHARD();
  
//   //   props.onFocus?.(e, fieldName);
//   // };
  
//   const handleFocus = (e) => {
//     setIsFocused(true);
  
//     // set RAW value on focus
//     const raw = stripMinusIfNotAllowed(stripFormatting(props.value));
//     setDisplayValue(raw);
  
//     // ✅ wait for Syncfusion + React render, then sticky select
//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         if (!isFocusedRef.current) return;
//         selectAllSticky();
//       });
//     });
  
//     props.onFocus?.(e, fieldName);
//   };
  
//   // const handleFocus = (e) => {
//   //   setIsFocused(true);
//   //   setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));

//   //   // ✅ must select always
//   //   selectAllReliable();

//   //   props.onFocus?.(e, fieldName);
//   // };

//   const handleBlur = (e) => {
//     setIsFocused(false);

//     const inputVal = e?.event?.target?.value ?? "";
//     const fixedStr = commitValue(inputVal);

//     setDisplayValue(formatForDisplay(fixedStr));

//     props.onBlur?.(fixedStr, fieldName);
//   };

//   const handleInput = (e) => {
//     let raw = e?.value ?? "";

//     // ✅ enforce non-negative in typing/paste
//     raw = stripMinusIfNotAllowed(raw);

//     setDisplayValue(raw);

//     const n = sanitizeNumber(toNumberSafe(raw));

//     // keep live string clean
//     const liveStr = decimals === 0 ? String(Math.trunc(n)) : stripFormatting(raw);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: liveStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(liveStr, fieldName);
//   };

//   const handleCreated = () => {
//     const initial = props.value ?? 0;
//     const fixedStr = toFixedString(toNumberSafe(initial));

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return updated;
//     });

//     setDisplayValue(formatForDisplay(fixedStr));

//     props.onCreated?.(null, fieldName);
//   };

//   // ✅ ArrowUp / ArrowDown update
//   const applyArrowStep = (dir) => {
//     const curNum = sanitizeNumber(toNumberSafe(displayValue));
//     const nextNum = sanitizeNumber(curNum + dir * step);
//     const nextStr = toFixedString(nextNum);

//     setDisplayValue(nextStr);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: nextStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(nextStr, fieldName);
//   };

//   const enabled = props?.enabled === false ? false : props.isView ? !props.isView : true;

//   return (
//     <div
//       onKeyDown={(e) => {
//         // prevent Enter submit
//         if (e.key === "Enter") {
//           e.preventDefault();
//           return;
//         }

//         // ✅ stop minus if not allowed
//         if (!allowNegative && (e.key === "-" || e.code === "Minus" || e.code === "NumpadSubtract")) {
//           e.preventDefault();
//           return;
//         }

//         // ✅ Arrow step
//         if (e.key === "ArrowUp") {
//           e.preventDefault();
//           applyArrowStep(+1);
//           return;
//         }
//         if (e.key === "ArrowDown") {
//           e.preventDefault();
//           applyArrowStep(-1);
//           return;
//         }
//       }}
//     >
//       <TextBoxComponent
//         className="e-input"
//         ref={textBoxRef}
//         type="text"
//         inputMode="decimal"
//         placeholder={props.caption ? props.caption : fieldName.replace(/([A-Z])/g, " $1").trim()}
//         name={`${fieldName}_display`}
//         id={`${fieldName}_display`}
//         floatLabelType="Auto"
//         value={displayValue}
//         cssClass="no-spin"
//         style={{ textAlign: "right", paddingRight: "8px" }}
//         created={handleCreated}
//         focus={handleFocus}
//         blur={handleBlur}
//         input={handleInput}
//         enabled={enabled}
//       />

//       {/* Hidden real value */}
//       <TextBoxComponent name={fieldName} id={fieldName} type="hidden" value={props.value} />
//     </div>
//   );
// };







// ---- 012126 - 03

// const DynamicNumericInput = (props) => {
//   // Normalize field name (string or {value})
//   const fieldName = useMemo(() => {
//     if (typeof props.name === "string") return props.name;
//     if (props.name && typeof props.name === "object" && typeof props.name.value === "string") return props.name.value;
//     return String(props.name ?? "");
//   }, [props.name]);

//   const decimals = useMemo(() => {
//     const d = typeof props.decimal === "number" ? props.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   }, [props.decimal]);

//   // ✅ AllowNagetive option (default true)
//   const allowNegative = useMemo(() => {
//     if (typeof props?.AllowNagetive === "boolean") return props.AllowNagetive;
//     if (typeof props?.allowNegative === "boolean") return props.allowNegative;
//     return true;
//   }, [props?.AllowNagetive, props?.allowNegative]);

//   // ✅ step option for ArrowUp/Down
//   const step = useMemo(() => {
//     const s = Number(props?.step || 1);
//     if (Number.isFinite(s) && s > 0) return s;
//     return decimals > 0 ? 1 / Math.pow(10, decimals) : 1;
//   }, [props?.step, decimals]);

//   const textBoxRef = useRef(null);
//   const [isFocused, setIsFocused] = useState(false);
//   const [displayValue, setDisplayValue] = useState("");

//   // ✅ Focus select pump refs
//   const focusPumpRef = useRef(null);
//   const focusPumpEndRef = useRef(0);
//   const rawOnFocusRef = useRef("");

//   // ------------------------
//   // Helpers
//   // ------------------------
//   const stripFormatting = (val) => {
//     const s = String(val ?? "").trim();
//     return s.replace(/,/g, "").replace(/\s+/g, "");
//   };

//   const stripMinusIfNotAllowed = (val) => {
//     const s = String(val ?? "");
//     if (allowNegative) return s;
//     return s.replace(/-/g, "");
//   };

//   const toNumberSafe = (val) => {
//     const raw = stripFormatting(val);
//     if (raw === "" || raw === "-" || raw === "." || raw === "-.") return 0;
//     const n = Number(raw);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const sanitizeNumber = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (!allowNegative && n < 0) return 0;
//     return n;
//   };

//   const roundToDecimals = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (decimals === 0) return Math.round(n);
//     return Number(Number(n).toFixed(decimals));
//   };

//   const toFixedString = (n) => {
//     const clean = sanitizeNumber(n);
//     const r = roundToDecimals(clean);
//     return decimals === 0 ? String(Math.round(r)) : Number(r).toFixed(decimals);
//   };

//   const formatForDisplay = (val) => {
//     const n = sanitizeNumber(toNumberSafe(val));
//     const r = roundToDecimals(n);
//     return Number(r).toLocaleString("en-US", {
//       minimumFractionDigits: decimals,
//       maximumFractionDigits: decimals,
//     });
//   };

//   const getFieldDecimals = (field) => {
//     const d = typeof field?.decimal === "number" ? field.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   };

//   const roundTo = (n, d) => {
//     if (!Number.isFinite(n)) return 0;
//     if (d === 0) return Math.round(n);
//     return Number(Number(n).toFixed(d));
//   };

//   const recalcFormulas = (values, changedField) => {
//     const next = { ...values };

//     for (let pass = 0; pass < 4; pass++) {
//       let anyChange = false;

//       for (const key of Object.keys(next)) {
//         const field = next[key];
//         if (!field || typeof field.formula !== "string") continue;

//         if (pass === 0 && !field.formula.includes(changedField)) continue;

//         const tokens = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
//         const context = {};

//         for (const t of tokens) {
//           if (!next[t]) continue;
//           context[t] = toNumberSafe(next[t].value); // do NOT round tokens
//         }

//         try {
//           // eslint-disable-next-line no-new-func
//           const result = new Function(...Object.keys(context), `return (${field.formula});`)(
//             ...Object.values(context)
//           );

//           const outDec = getFieldDecimals(field);
//           const outNum = Number.isFinite(Number(result)) ? Number(result) : 0;
//           const finalNum = roundTo(outNum, outDec);
//           const finalStr = outDec === 0 ? String(Math.round(finalNum)) : finalNum.toFixed(outDec);

//           if (String(field.value ?? "") !== finalStr) {
//             next[key] = { ...field, value: finalStr };
//             anyChange = true;
//           }
//         } catch {
//           // ignore formula errors
//         }
//       }

//       if (!anyChange) break;
//     }

//     return next;
//   };

//   // ------------------------
//   // Get input element
//   // ------------------------
//   const getInputEl = () => {
//     const inst = textBoxRef.current;
//     return inst?.inputElement || inst?.element?.querySelector("input");
//   };

//   // ✅ HARD set Syncfusion value immediately
//   const setEJ2ValueNow = (val) => {
//     const inst = textBoxRef.current;
//     const v = String(val ?? "");

//     if (inst) {
//       inst.value = v;
//       inst.dataBind?.();
//     }

//     const el = getInputEl();
//     if (el && el.value !== v) el.value = v;
//   };

//   // ✅ STOP pump
//   const stopFocusPump = () => {
//     if (focusPumpRef.current) {
//       clearInterval(focusPumpRef.current);
//       focusPumpRef.current = null;
//     }
//   };

//   // ✅ START pump: LOCK raw value + SELECT ALL for some time
//   const startFocusPump = (raw, durationMs = 900) => {
//     stopFocusPump();

//     rawOnFocusRef.current = String(raw ?? "");
//     focusPumpEndRef.current = Date.now() + durationMs;

//     focusPumpRef.current = setInterval(() => {
//       const el = getInputEl();
//       if (!el) return;

//       if (!isFocused) {
//         stopFocusPump();
//         return;
//       }

//       if (Date.now() > focusPumpEndRef.current) {
//         stopFocusPump();
//         return;
//       }

//       // 🔥 Syncfusion keeps rewriting value (especially when previous was "1,000")
//       // so we keep LOCKING raw value + selection
//       const r = rawOnFocusRef.current;

//       setEJ2ValueNow(r);

//       try {
//         el.focus({ preventScroll: true });
//         el.setSelectionRange(0, r.length);
//       } catch {
//         el.select?.();
//       }
//     }, 8); // aggressive

//     // safety final select
//     setTimeout(() => {
//       const el = getInputEl();
//       if (!el || !isFocused) return;
//       const r = rawOnFocusRef.current;
//       try {
//         el.setSelectionRange(0, r.length);
//       } catch {
//         el.select?.();
//       }
//     }, 250);
//   };

//   // ------------------------
//   // Sync local display with props.value
//   // ------------------------
//   useEffect(() => {
//     if (isFocused) {
//       setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));
//     } else {
//       setDisplayValue(formatForDisplay(props.value));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [props.value, isFocused, decimals, allowNegative]);

//   // cleanup
//   useEffect(() => {
//     return () => stopFocusPump();
//   }, []);

//   // ------------------------
//   // Commit value to parent state (and recalc formulas)
//   // ------------------------
//   const commitValue = (rawInput) => {
//     const cleanedRaw = stripMinusIfNotAllowed(rawInput);
//     const n = sanitizeNumber(toNumberSafe(cleanedRaw));
//     const fixedStr = toFixedString(n);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     return fixedStr;
//   };

//   // ------------------------
//   // Events
//   // ------------------------
//   const handleFocus = (e) => {
//     setIsFocused(true);

//     // RAW (no commas)
//     const raw = stripMinusIfNotAllowed(stripFormatting(props.value));
//     setDisplayValue(raw);

//     // MUST force value right now
//     setEJ2ValueNow(raw);

//     // ✅ start pump AFTER a tiny delay (Syncfusion focus pipeline)
//     setTimeout(() => {
//       startFocusPump(raw, 900);
//     }, 0);

//     props.onFocus?.(e, fieldName);
//   };

//   const handleBlur = (e) => {
//     stopFocusPump();
//     setIsFocused(false);

//     const inputVal = e?.event?.target?.value ?? "";
//     const fixedStr = commitValue(inputVal);

//     setDisplayValue(formatForDisplay(fixedStr));

//     props.onBlur?.(fixedStr, fieldName);
//   };

//   const handleInput = (e) => {
//     // ✅ user started typing => stop pump (otherwise it will keep reselecting)
//     stopFocusPump();

//     let raw = e?.value ?? "";
//     raw = stripMinusIfNotAllowed(raw);

//     setDisplayValue(raw);

//     const n = sanitizeNumber(toNumberSafe(raw));
//     const liveStr = decimals === 0 ? String(Math.trunc(n)) : stripFormatting(raw);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: liveStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(liveStr, fieldName);
//   };

//   const handleCreated = () => {
//     // Initialize if undefined/null
//     const initial = props.value ?? 0;
//     const fixedStr = toFixedString(toNumberSafe(initial));

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return updated;
//     });

//     setDisplayValue(formatForDisplay(fixedStr));

//     // ✅ mouse click also triggers caret placement -> pump again
//     setTimeout(() => {
//       const el = getInputEl();
//       if (!el) return;
//       if (el.__dynNumBound) return;

//       el.__dynNumBound = true;
//       el.addEventListener(
//         "mouseup",
//         () => {
//           if (!isFocused) return;
//           startFocusPump(rawOnFocusRef.current, 600);
//         },
//         true
//       );
//     }, 0);

//     props.onCreated?.(null, fieldName);
//   };

//   // ✅ ArrowUp / ArrowDown update
//   const applyArrowStep = (dir) => {
//     const curNum = sanitizeNumber(toNumberSafe(displayValue));
//     const nextNum = sanitizeNumber(curNum + dir * step);
//     const nextStr = toFixedString(nextNum);

//     setDisplayValue(nextStr);
//     setEJ2ValueNow(nextStr);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: nextStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(nextStr, fieldName);

//     // keep it selected after arrow change
//     startFocusPump(nextStr, 250);
//   };

//   const enabled = props?.enabled === false ? false : props.isView ? !props.isView : true;

//   return (
//     <div
//       onKeyDown={(e) => {
//         if (e.key === "Enter") {
//           e.preventDefault();
//           return;
//         }

//         if (!allowNegative && (e.key === "-" || e.code === "Minus" || e.code === "NumpadSubtract")) {
//           e.preventDefault();
//           return;
//         }

//         if (e.key === "ArrowUp") {
//           e.preventDefault();
//           applyArrowStep(+1);
//           return;
//         }
//         if (e.key === "ArrowDown") {
//           e.preventDefault();
//           applyArrowStep(-1);
//           return;
//         }
//       }}
//     >
//       <TextBoxComponent
//         className="e-input"
//         ref={textBoxRef}
//         type="text"
//         inputMode="decimal"
//         placeholder={props.caption ? props.caption : fieldName.replace(/([A-Z])/g, " $1").trim()}
//         name={`${fieldName}_display`}
//         id={`${fieldName}_display`}
//         floatLabelType="Auto"
//         value={displayValue}
//         cssClass="no-spin"
//         style={{ textAlign: "right", paddingRight: "8px" }}
//         created={handleCreated}
//         focus={handleFocus}
//         blur={handleBlur}
//         input={handleInput}
//         enabled={enabled}
//       />

//       {/* Hidden real value */}
//       <TextBoxComponent name={fieldName} id={fieldName} type="hidden" value={props.value} />
//     </div>
//   );
// };











// const DynamicNumericInput = (props) => {
//   // Normalize field name (string or {value})
//   const fieldName = useMemo(() => {
//     if (typeof props.name === "string") return props.name;
//     if (props.name && typeof props.name === "object" && typeof props.name.value === "string") return props.name.value;
//     return String(props.name ?? "");
//   }, [props.name]);

//   const decimals = useMemo(() => {
//     const d = typeof props.decimal === "number" ? props.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   }, [props.decimal]);

//   // ✅ AllowNagetive option (default true)
//   const allowNegative = useMemo(() => {
//     if (typeof props?.AllowNagetive === "boolean") return props.AllowNagetive;
//     if (typeof props?.allowNegative === "boolean") return props.allowNegative;
//     return true; // default allow negative
//   }, [props?.AllowNagetive, props?.allowNegative]);

//   // ✅ step option for ArrowUp/Down
//   const step = useMemo(() => {
//     const s = Number(props?.step || 1);
//     if (Number.isFinite(s) && s > 0) return s;
//     // default: if decimals -> smallest meaningful step, else 1
//     return decimals > 0 ? 1 / Math.pow(10, decimals) : 1;
//   }, [props?.step, decimals]);

//   const textBoxRef = useRef(null);
//   const [isFocused, setIsFocused] = useState(false);
//   const [displayValue, setDisplayValue] = useState("");

//   // ------------------------
//   // Helpers
//   // ------------------------
//   const stripFormatting = (val) => {
//     const s = String(val ?? "").trim();
//     return s.replace(/,/g, "").replace(/\s+/g, "");
//   };

//   const stripMinusIfNotAllowed = (val) => {
//     const s = String(val ?? "");
//     if (allowNegative) return s;
//     // remove all minus signs
//     return s.replace(/-/g, "");
//   };

//   const toNumberSafe = (val) => {
//     const raw = stripFormatting(val);
//     if (raw === "" || raw === "-" || raw === "." || raw === "-.") return 0;
//     const n = Number(raw);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const sanitizeNumber = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (!allowNegative && n < 0) return 0;
//     return n;
//   };

//   const roundToDecimals = (n) => {
//     if (!Number.isFinite(n)) return 0;
//     if (decimals === 0) return Math.round(n);
//     return Number(Number(n).toFixed(decimals));
//   };

//   const toFixedString = (n) => {
//     const clean = sanitizeNumber(n);
//     const r = roundToDecimals(clean);
//     return decimals === 0 ? String(Math.round(r)) : Number(r).toFixed(decimals);
//   };

//   const formatForDisplay = (val) => {
//     const n = sanitizeNumber(toNumberSafe(val));
//     const r = roundToDecimals(n);
//     return Number(r).toLocaleString("en-US", {
//       minimumFractionDigits: decimals,
//       maximumFractionDigits: decimals,
//     });
//   };

//   const getFieldDecimals = (field) => {
//     const d = typeof field?.decimal === "number" ? field.decimal : 0;
//     return Number.isFinite(d) ? Math.max(0, d) : 0;
//   };

//   const roundTo = (n, d) => {
//     if (!Number.isFinite(n)) return 0;
//     if (d === 0) return Math.round(n);
//     return Number(Number(n).toFixed(d));
//   };

//   const recalcFormulas = (values, changedField) => {
//     const next = { ...values };

//     for (let pass = 0; pass < 4; pass++) {
//       let anyChange = false;

//       for (const key of Object.keys(next)) {
//         const field = next[key];
//         if (!field || typeof field.formula !== "string") continue;

//         if (pass === 0 && !field.formula.includes(changedField)) continue;

//         const tokens = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
//         const context = {};

//         for (const t of tokens) {
//           if (!next[t]) continue;
//           context[t] = toNumberSafe(next[t].value); // do NOT round tokens here
//         }

//         try {
//           // eslint-disable-next-line no-new-func
//           const result = new Function(...Object.keys(context), `return (${field.formula});`)(
//             ...Object.values(context)
//           );

//           const outDec = getFieldDecimals(field);
//           const outNum = Number.isFinite(Number(result)) ? Number(result) : 0;
//           const finalNum = roundTo(outNum, outDec);
//           const finalStr = outDec === 0 ? String(Math.round(finalNum)) : finalNum.toFixed(outDec);

//           if (String(field.value ?? "") !== finalStr) {
//             next[key] = { ...field, value: finalStr };
//             anyChange = true;
//           }
//         } catch {
//           // ignore formula errors
//         }
//       }

//       if (!anyChange) break;
//     }

//     return next;
//   };

//   // ------------------------
//   // Sync local display with props.value
//   // ------------------------
//   useEffect(() => {
//     if (isFocused) {
//       setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));
//     } else {
//       setDisplayValue(formatForDisplay(props.value));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [props.value, isFocused, decimals, allowNegative]);

//   // ------------------------
//   // Commit value to parent state (and recalc formulas)
//   // ------------------------
//   const commitValue = (rawInput) => {
//     const cleanedRaw = stripMinusIfNotAllowed(rawInput);
//     const n = sanitizeNumber(toNumberSafe(cleanedRaw));
//     const fixedStr = toFixedString(n);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     return fixedStr;
//   };

//   // ------------------------
//   // Get input element
//   // ------------------------
//  // ✅ display input id
// const displayId = useMemo(() => `${fieldName}_display`, [fieldName]);

// // ✅ Get input element by ID (most reliable)
//  const getInputEl = () => {
//     const inst = textBoxRef.current;
//     return inst?.inputElement || inst?.element?.querySelector("input");
//   };
// const getInputElById = () => {
//   const node = document.getElementById(displayId);
//   if (!node) return null;

//   // sometimes Syncfusion wraps, so check input inside too
//   if (node.tagName === "INPUT") return node;
//   return node.querySelector("input");
// };

// // ✅ SUPER reliable select-all using ID 
// const selectAllReliable = () => {      
//   const trySelect = () => {
//     const el = getInputElById() || getInputEl(); // ✅ prefer ID, fallback ref
//     if (!el) return false;

//     el.focus();

//     const len = el.value?.length ?? 0;
//     try {
//       el.setSelectionRange(0, len);
//     } catch {
//       if (typeof el.select === "function") el.select();
//     }
//     return true;
//   };

//   // multiple attempts (Syncfusion re-renders can kill selection)
//   // trySelect();
//   // requestAnimationFrame(() => trySelect());
//   requestAnimationFrame(() => requestAnimationFrame(() => trySelect()));
//   setTimeout(() => trySelect(), 0);
//   setTimeout(() => trySelect(), 40);
//   setTimeout(() => trySelect(), 120);
// };

//   // ------------------------
//   // Events
//   // ------------------------
//   const handleFocus = (e) => {
//     setIsFocused(true);
//     setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));

//     // ✅ must select always
//     selectAllReliable();

//     props.onFocus?.(e, fieldName);
//   };

//   const handleBlur = (e) => {
//     setIsFocused(false);

//     const inputVal = e?.event?.target?.value ?? "";
//     const fixedStr = commitValue(inputVal);

//     setDisplayValue(formatForDisplay(fixedStr));

//     props.onBlur?.(fixedStr, fieldName);
//   };

//   const handleInput = (e) => {
//     let raw = e?.value ?? "";

//     // ✅ enforce non-negative in typing/paste
//     raw = stripMinusIfNotAllowed(raw);

//     setDisplayValue(raw);

//     const n = sanitizeNumber(toNumberSafe(raw));

//     // keep live string clean
//     const liveStr = decimals === 0 ? String(Math.trunc(n)) : stripFormatting(raw);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: liveStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(liveStr, fieldName);
//   };

//   const handleCreated = () => {
//     const initial = props.value ?? 0;
//     const fixedStr = toFixedString(toNumberSafe(initial));

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: fixedStr,
//         },
//       };
//       return updated;
//     });

//     setDisplayValue(formatForDisplay(fixedStr));

//     props.onCreated?.(null, fieldName);
//   };

//   // ✅ ArrowUp / ArrowDown update
//   const applyArrowStep = (dir) => {
//     const curNum = sanitizeNumber(toNumberSafe(displayValue));
//     const nextNum = sanitizeNumber(curNum + dir * step);
//     const nextStr = toFixedString(nextNum);

//     setDisplayValue(nextStr);

//     props.setInputProps((prev) => {
//       const updated = {
//         ...prev,
//         [fieldName]: {
//           ...prev[fieldName],
//           value: nextStr,
//         },
//       };
//       return recalcFormulas(updated, fieldName);
//     });

//     props.onChange?.(nextStr, fieldName);
//   };

//   const enabled = props?.enabled === false ? false : props.isView ? !props.isView : true;

//   return (
//     <div
//       onKeyDown={(e) => {
//         // prevent Enter submit
//         if (e.key === "Enter") {
//           e.preventDefault();
//           return;
//         }

//         // ✅ stop minus if not allowed
//         if (!allowNegative && (e.key === "-" || e.code === "Minus" || e.code === "NumpadSubtract")) {
//           e.preventDefault();
//           return;
//         }

//         // ✅ Arrow step
//         if (e.key === "ArrowUp") {
//           e.preventDefault();
//           applyArrowStep(+1);
//           return;
//         }
//         if (e.key === "ArrowDown") {
//           e.preventDefault();
//           applyArrowStep(-1);
//           return;
//         }
//       }}
//     >
//       <TextBoxComponent
//         className="e-input"
//         ref={textBoxRef}
//         type="text"
//         inputMode="decimal"
//         placeholder={props.caption ? props.caption : fieldName.replace(/([A-Z])/g, " $1").trim()}
//         name={`${fieldName}_display`}
//         id={`${fieldName}_display`}
//         floatLabelType="Auto"
//         value={displayValue}
//         cssClass="no-spin"
//         style={{ textAlign: "right", paddingRight: "8px" }}
//         created={handleCreated}
//         focus={handleFocus}
//         blur={handleBlur}
//         input={handleInput}
//         enabled={enabled}
//       />

//       {/* Hidden real value */}
//       <TextBoxComponent name={fieldName} id={fieldName} type="hidden" value={props.value} />
//     </div>
//   );
// };









// import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
// import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";

const DynamicNumericInput = (props) => {
  // ------------------------
  // Normalize field name (string or {value})
  // ------------------------
  const fieldName = useMemo(() => {
    if (typeof props.name === "string") return props.name;
    if (props.name && typeof props.name === "object" && typeof props.name.value === "string") return props.name.value;
    return String(props.name ?? "");
  }, [props.name]);

  const displayId = useMemo(() => `${fieldName}_display`, [fieldName]);

  const decimals = useMemo(() => {
    const d = typeof props.decimal === "number" ? props.decimal : 0;
    return Number.isFinite(d) ? Math.max(0, d) : 0;
  }, [props.decimal]);

  // ✅ AllowNegative option (default true)
  const allowNegative = useMemo(() => {
    if (typeof props?.AllowNagetive === "boolean") return props.AllowNagetive;
    if (typeof props?.allowNegative === "boolean") return props.allowNegative;
    return true;
  }, [props?.AllowNagetive, props?.allowNegative]);

  // ✅ step option for ArrowUp/Down
  const step = useMemo(() => {
    const s = Number(props?.step || 1);
    if (Number.isFinite(s) && s > 0) return s;
    return decimals > 0 ? 1 / Math.pow(10, decimals) : 1;
  }, [props?.step, decimals]);

  const textBoxRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const [displayValue, setDisplayValue] = useState("");

  // ------------------------
  // Selection anti-fluctuation control
  // ------------------------
  const focusTokenRef = useRef(0);
  const selectTimersRef = useRef([]);
  const selectRafsRef = useRef([]);

  const clearSelectJobs = () => {
    selectTimersRef.current.forEach(clearTimeout);
    selectTimersRef.current = [];

    selectRafsRef.current.forEach(cancelAnimationFrame);
    selectRafsRef.current = [];
  };

  useEffect(() => {
    return () => clearSelectJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------------
  // Helpers
  // ------------------------
  const stripFormatting = (val) => {
    const s = String(val ?? "").trim();
    return s.replace(/,/g, "").replace(/\s+/g, "");
  };

  const stripMinusIfNotAllowed = (val) => {
    const s = String(val ?? "");
    if (allowNegative) return s;
    return s.replace(/-/g, "");
  };

  const toNumberSafe = (val) => {
    const raw = stripFormatting(val);
    if (raw === "" || raw === "-" || raw === "." || raw === "-.") return 0;
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  };

  const sanitizeNumber = (n) => {
    if (!Number.isFinite(n)) return 0;
    if (!allowNegative && n < 0) return 0;
    return n;
  };

  const roundToDecimals = (n) => {
    if (!Number.isFinite(n)) return 0;
    if (decimals === 0) return Math.round(n);
    return Number(Number(n).toFixed(decimals));
  };

  const toFixedString = (n) => {
    const clean = sanitizeNumber(n);
    const r = roundToDecimals(clean);
    return decimals === 0 ? String(Math.round(r)) : Number(r).toFixed(decimals);
  };

  const formatForDisplay = (val) => {
    const n = sanitizeNumber(toNumberSafe(val));
    const r = roundToDecimals(n);
    return Number(r).toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  const getFieldDecimals = (field) => {
    const d = typeof field?.decimal === "number" ? field.decimal : 0;
    return Number.isFinite(d) ? Math.max(0, d) : 0;
  };

  const roundTo = (n, d) => {
    if (!Number.isFinite(n)) return 0;
    if (d === 0) return Math.round(n);
    return Number(Number(n).toFixed(d));
  };

  const recalcFormulas = (values, changedField) => {
    const next = { ...values };

    for (let pass = 0; pass < 4; pass++) {
      let anyChange = false;

      for (const key of Object.keys(next)) {
        const field = next[key];
        if (!field || typeof field.formula !== "string") continue;

        if (pass === 0 && !field.formula.includes(changedField)) continue;

        const tokens = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
        const context = {};

        for (const t of tokens) {
          if (!next[t]) continue;
          context[t] = toNumberSafe(next[t].value);
        }

        try {
          // eslint-disable-next-line no-new-func
          const result = new Function(...Object.keys(context), `return (${field.formula});`)(
            ...Object.values(context)
          );

          const outDec = getFieldDecimals(field);
          const outNum = Number.isFinite(Number(result)) ? Number(result) : 0;
          const finalNum = roundTo(outNum, outDec);
          const finalStr = outDec === 0 ? String(Math.round(finalNum)) : finalNum.toFixed(outDec);

          if (String(field.value ?? "") !== finalStr) {
            next[key] = { ...field, value: finalStr };
            anyChange = true;
          }
        } catch {
          // ignore formula errors
        }
      }

      if (!anyChange) break;
    }

    return next;
  };

  // ------------------------
  // Commit value to parent state (and recalc formulas)
  // ------------------------
  const commitValue = (rawInput) => {
    const cleanedRaw = stripMinusIfNotAllowed(rawInput);
    const n = sanitizeNumber(toNumberSafe(cleanedRaw));
    const fixedStr = toFixedString(n);

    props.setInputProps((prev) => {
      const updated = {
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          value: fixedStr,
        },
      };
      return recalcFormulas(updated, fieldName);
    });

    return fixedStr;
  };

  // ------------------------
  // Get input element (Ref + ID)
  // ------------------------
  const getInputEl = () => {
    const inst = textBoxRef.current;
    return inst?.inputElement || inst?.element?.querySelector("input");
  };

  const getInputElById = () => {
    const node = document.getElementById(displayId);
    if (!node) return null;

    if (node.tagName === "INPUT") return node;
    return node.querySelector("input");
  };

  // ✅ Stable select-all (NO fluctuation on fast focus switching)
  const selectAllReliable = () => {
    clearSelectJobs();

    const token = ++focusTokenRef.current;

    const trySelect = () => {
      if (token !== focusTokenRef.current) return;

      const el = getInputElById() || getInputEl();
      if (!el) return;

      const len = el.value?.length ?? 0;

      // don't refocus repeatedly (jerk)
      if (document.activeElement !== el) {
        el.focus?.({ preventScroll: true });
      }

      try {
        el.setSelectionRange(0, len);
      } catch {
        el.select?.();
      }
    };

    // microtask (fast)
    if (typeof queueMicrotask === "function") queueMicrotask(trySelect);
    else Promise.resolve().then(trySelect);

    // 1 RAF + 1 small timeout (enough for Syncfusion)
    const r1 = requestAnimationFrame(trySelect);
    selectRafsRef.current.push(r1);

    selectTimersRef.current.push(setTimeout(trySelect, 25));
  };

  // ------------------------
  // Sync local display with props.value (reduce flicker)
  // ------------------------
  useLayoutEffect(() => {
    if (isFocused) {
      setDisplayValue(stripMinusIfNotAllowed(stripFormatting(props.value)));
    } else {
      setDisplayValue(formatForDisplay(props.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, isFocused, decimals, allowNegative]);

  // ------------------------
  // Events
  // ------------------------
  const handleFocus = (e) => {
    clearSelectJobs();
    setIsFocused(true);

    // ✅ always select on focus
    selectAllReliable();

    props.onFocus?.(e, fieldName);
  };

  const handleBlur = (e) => {
    clearSelectJobs();
    setIsFocused(false);

    const inputVal = e?.event?.target?.value ?? "";
    const fixedStr = commitValue(inputVal);

    setDisplayValue(formatForDisplay(fixedStr));
    props.onBlur?.(fixedStr, fieldName);
  };

  const handleInput = (e) => {
    let raw = e?.value ?? "";

    // ✅ enforce non-negative in typing/paste
    raw = stripMinusIfNotAllowed(raw);

    setDisplayValue(raw);

    const n = sanitizeNumber(toNumberSafe(raw));

    // keep live string clean
    const liveStr = decimals === 0 ? String(Math.trunc(n)) : stripFormatting(raw);

    props.setInputProps((prev) => {
      const updated = {
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          value: liveStr,
        },
      };
      return recalcFormulas(updated, fieldName);
    });

    props.onChange?.(liveStr, fieldName);
  };

  const handleCreated = () => {
    const initial = props.value ?? 0;
    const fixedStr = toFixedString(toNumberSafe(initial));

    props.setInputProps((prev) => {
      const updated = {
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          value: fixedStr,
        },
      };
      return updated;
    });

    setDisplayValue(formatForDisplay(fixedStr));
    props.onCreated?.(null, fieldName);
  };

  // ✅ ArrowUp / ArrowDown update
  const applyArrowStep = (dir) => {
    const curNum = sanitizeNumber(toNumberSafe(displayValue));
    const nextNum = sanitizeNumber(curNum + dir * step);
    const nextStr = toFixedString(nextNum);

    setDisplayValue(nextStr);

    props.setInputProps((prev) => {
      const updated = {
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          value: nextStr,
        },
      };
      return recalcFormulas(updated, fieldName);
    });

    props.onChange?.(nextStr, fieldName);
  };

  const enabled = props?.enabled === false ? false : props.isView ? !props.isView : true;

  return (
    <div
      onKeyDown={(e) => {
        // prevent Enter submit
        if (e.key === "Enter") {
          e.preventDefault();
          return;
        }

        // ✅ stop minus if not allowed
        if (!allowNegative && (e.key === "-" || e.code === "Minus" || e.code === "NumpadSubtract")) {
          e.preventDefault();
          return;
        }

        // ✅ Arrow step
        if (e.key === "ArrowUp") {
          e.preventDefault();
          applyArrowStep(+1);
          return;
        }
        if (e.key === "ArrowDown") {
          e.preventDefault();
          applyArrowStep(-1);
          return;
        }
      }}
    >
      <TextBoxComponent
        className="e-input"
        ref={textBoxRef}
        type="text"
        inputMode="decimal"
        placeholder={props.caption ? props.caption : fieldName.replace(/([A-Z])/g, " $1").trim()}
        name={displayId}
        id={displayId}
        floatLabelType="Auto"
        value={displayValue}
        cssClass="no-spin"
        style={{ textAlign: "right", paddingRight: "8px" }}
        created={handleCreated}
        focus={handleFocus}
        blur={handleBlur}
        input={handleInput}
        enabled={enabled}
      />

      {/* Hidden real value */}
      <TextBoxComponent name={fieldName} id={fieldName} type="hidden" value={props.value} />
    </div>
  );
};





























































// 123126 KO COMMENT KAR RAH HUN YE OK CODE RUNING CODE HAI
// const DynamicNumericInput = (props) => {
//     console.log(props)
//   const [inputType, setInputType] = useState('text');
//   const [blur, setBlur] = useState(false);
//   const [displayValue, setDisplayValue] = useState(props.value || 0.0);

//   const refs = useRef({});

//   // Assign a dynamic ref based on the name prop
//   if (!refs.current[props.name.value]) {
//     refs.current[props.name.value] = React.createRef();
//   }
//   const textBoxRef = refs.current[props.name.value];
  
//   useEffect(() => {
//     setBlur(true)
//   }, [props.name]);
//   useEffect(() => {
//   setBlur(true)
//     if (inputType === 'text') {
//       setDisplayValue(props.value.toLocaleString('en-US', { minimumFractionDigits: props.decimal || 0, maximumFractionDigits: props.decimal || 0 }));
//     } else {
//       setDisplayValue(props.value);
//     }
//   }, [props.value]);
//   // }, [displayValue]);

//   const formatNumberWithCommas = (number) => {
//     let comma = number.toLocaleString('en-US', { minimumFractionDigits: props.decimal || 0, maximumFractionDigits: props.decimal || 0 });
//     console.log(comma)
//     return comma
//   };

//   const handleChange = (e) => {
//     const value = e?.value === "" ? props.value : e.value;

//     props.setInputProps((prevValues) => {
//       // Update the changed value first
//       const newValues = {
//         ...prevValues,
//         [props.name]: {
//           ...prevValues[props.name],
//           value: value
//         }
//       };

//       // Only update formula fields that reference this input
//       Object.keys(newValues).forEach((key) => {
//         const field = newValues[key];
//         if (
//           field.formula &&
//           typeof field.formula === "string" &&
//           field.formula.includes(props.name)
//         ) {
//           // Extract referenced field names from formula
//           const fieldNames = field.formula.match(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g) || [];
//           const context = {};
//           fieldNames.forEach(f => {
//             if (newValues[f]) {
//               let v = parseFloat(newValues[f].value) || 0;
//               if (typeof newValues[f].decimal === "number") {
//                 if (newValues[f].decimal === 0) {
//                   v = Math.round(parseInt(v));
//                 } else {
//                   v = parseFloat(parseFloat(v).toFixed(newValues[f].decimal));
//                 }
//               }
//               context[f] = v;
//             }
//           });
//           try {
//             // eslint-disable-next-line no-new-func
//             const result =new Function(...Object.keys(context), `return ${field.formula}`)(...Object.values(context));
//             let decimalPlaces = (typeof field.decimal === "number") ? field.decimal : 0;
//             let formatted; 
//             if (decimalPlaces === 0) {
//               formatted = Math.round(parseInt(result));
//             } else {
//               formatted = parseFloat(parseFloat(result).toFixed(decimalPlaces));
//             }
//             field.value = formatted;
//           } catch (err) {
//             // ignore errors
//           }
//         }
//       });

//       return newValues;
//     });
//     setDisplayValue(value);
//   };



//   const formatNumber = (value) => {
//   return value.replace(/^(-?\d+)(\.\d+)?$/, (_, intPart, decimalPart) =>
//     intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (decimalPart || "")
//   );
// };

//   const handleBlur = (e) => {
//     console.log(e);
//     const formattedValue = e?.event.target?.value === "" ? parseFloat(0).toFixed(props.decimal || 0) : parseFloat(e.event.target.value).toFixed(props.decimal || 0);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: formattedValue
//       }
//     }));
//     // document.getElementById(`${props.name}_display`).blur()
//     console.log(formattedValue)
//     setInputType('text'); // Change back to text on blur
    
    
//     console.log(typeof formattedValue)
//     // console.log(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","))
//     console.log(formattedValue.replace(/^(\d+)(\.\d+)?$/, (_, intPart, decimalPart) =>
//   intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (decimalPart || "")
// ));
//     // setDisplayValue(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
//     setDisplayValue(formatNumber(formattedValue));
//   };

//   const handleFocus = (e) => {
//     console.log(e);
//     setInputType('number'); // Change to number on focus
//     setDisplayValue(props.value);
//     if (props.onFocus) {
//       props.onFocus(e, props.name);
//     }
    
//     setTimeout(()=>{
//       if( textBoxRef.current  && textBoxRef.current.element){
//         console.log(textBoxRef.current)
//       }
//     },500)
//     // e.target.elementRef.current.select()
//     // e.target.                       value.select()
//     if(blur == false){
//       // textBoxRef.current.element.select()
//     }
//     setBlur(false)
    
//   };

//   const handleCreated = (e) => {
//     console.log(e);
//     const value = props.value || 0.0;
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value,
//       }
//     }));
//     setDisplayValue(formatNumberWithCommas(value));
//   };


//   const lastFocusedName = useRef(null);

// const handleInputFocus = (e) => {
//   const inputName = props.name;

//   // Prevent repeated focus if already focused
//   if (lastFocusedName.current === inputName) return;

//   lastFocusedName.current = inputName;

//   requestAnimationFrame(() => {
//     e?.event?.target?.select();
//   });

//   handleFocus?.(e);
//   props.onFocus?.(e, inputName);
// };

// const handleInputBlur = () => {
//   lastFocusedName.current = null;
// };
//   return (
//     <div onKeyDown={(e)=>{
//       console.log(e)
//       if(e.code == 'Enter'){
//       e.preventDefault()
//       }
//     }}>
//       <TextBoxComponent
//         className='e-input'
//         ref={textBoxRef}
//         type={inputType}
//         // type={'number'}
//         placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//         name={`${props.name}_display`}
//         id={`${props.name}_display`}
//         floatLabelType='Auto'
//         value={displayValue}
//         cssClass='no-spin'
//         style={{textAlign:'right',paddingRight:'8px'}}
//         created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
//         blur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e?.event.target.value, props.name) : null)}
//         // focus={(e) => (setTimeout(()=>{ document.getElementById(e?.event?.target?.id).select()},5),handleFocus(e), props.onFocus ? props.onFocus(e, props.name) : null)}

//       //      focus={(e) => {
//       //   requestAnimationFrame(() => {
//       //     e?.event?.target?.select();
//       //   });
//       //   handleFocus(e);
//       //   if (props.onFocus) props.onFocus(e, props.name);
//       // }}
//       focus={handleInputFocus}
//         input={(e) => (  handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         onChange={(e) => (  handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         // enabled={props?.enabled  ? props?.enabled :   props.isView ? !props.isView : true}
//         enabled={props?.enabled == false  ?  props?.enabled :    props.isView ? !props.isView : true}     

//       />
//   <TextBoxComponent
//         name={props.name}
//         id={props.name}
//         type='hidden'
//         value={props.value}

//   />
//     </div>
//   );
// };
 


// const DynamicNumericInput = (props) => {
//   const [inputType, setInputType] = useState('text');
//   const [displayValue, setDisplayValue] = useState('');
//   const [actualValue, setActualValue] = useState(props.value || 0.0);

//   useEffect(() => {
//     if (inputType === 'text') {
//       setDisplayValue(formatNumberWithCommas(actualValue));
//     } else {
//       setDisplayValue(actualValue);
//     }
//   }, [inputType, actualValue]);

//   const formatNumberWithCommas = (number) => {
//     return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   const handleChange = (e) => {
//     const value = e?.value === "" ? 0 : e.value;
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value
//       }
//     }));
//     setDisplayValue(value);
//   };

//   const handleBlur = (e) => {
//     setInputType('text');
//     setDisplayValue(''); // Hide value on blur
//     const value = e?.target?.value === "" ? 0 : parseFloat(e.target.value).toFixed(props.decimal || 0);
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value
//       }
//     }));
//   };

//   const handleFocus = (e) => {
//     setInputType('number');
//     setDisplayValue(actualValue);
//     if (props.onFocus) {
//       props.onFocus(e, props.name);
//     }
//   };

//   const handleCreated = (e) => {
//     // let value = props.value < 1000 ? 0 : props.value;
//     console.log(props.value)
//     let value =  props.value || 0;
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value,
//       }
//     }));
//     console.log(formatNumberWithCommas(value))
//     setDisplayValue(formatNumberWithCommas(value));
//   };

//   return (
//     <>
//       <TextBoxComponent
//         className='e-input'
//         type={inputType}
//         placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//         name={props.name}
//         id={props.name}
//         floatLabelType='Auto'
//         value={displayValue}
//         created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
//         onBlur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
//         onFocus={handleFocus}
//         onChange={(e) => (handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         enabled={props?.enabled === false ? props?.enabled : true}
//       />
//     </>
//   );
// };
 

const DynamicTextInput = (props) => {
  console.log(props)
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value == "" ? prevValues[props.name].value :  e.value}
    }));
  };
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value == "" ?  "" : e.target.value}
    }));
  };
  const handleCreated = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :props.value || ""}
    }));
  };
  return (
    <div onKeyDown={(e)=>{
      console.log(e)
      if(e.code == 'Enter'){
      e.preventDefault()
      }
    }}
      >
      <TextBoxComponent
        className='e-input'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        // ref={textBoxRef}

        type={props.type ? props.type : 'text'}
        value={props.value || ''}
        created={(e)=>(handleCreated(e) , props.onCreated ? props.onCreated(e, props.name) : null )}
        onBlur={(e)=>(handleBlur(e) , props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (handleChange(e) , props.onChange ? props.onChange(e.value, props.name) : null)}
        enabled={props?.enabled == false  ?  props?.enabled :    props.isView ? !props.isView : true}     
        // disabled={!props?.enabled  false}
              
          multiline={props?.multiline || false} 
    
        />
    </div>
  );
};



const DynamicCellInput = (props) => {
  const tooltipRef = useRef(null);
  
  const showTooltip = (target, message) => {
    if (tooltipRef.current) {
      tooltipRef.current.destroy(); // Destroy existing tooltip if any
    }
    tooltipRef.current = new TooltipComponent({
      content: `<span class="error-tooltip">${message}</span>`,
      position: 'TopCenter',
    });
    tooltipRef.current.appendTo(target);
    tooltipRef.current.open(target);
  };
  
  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close(); // Close the tooltip
      tooltipRef.current.destroy(); // Destroy the tooltip instance
      tooltipRef.current = null; // Reset the ref
    }
  };
  const [errorMessage, setErrorMessage] = useState('');
  const refs = useRef({});

  // Assign a dynamic ref based on the name prop
  if (!refs.current[props.name]) {
    refs.current[props.name] = React.createRef();
  }
  const textBoxRef = refs.current[props.name];

  const handleChange = (e) => {
    const inputValue = e?.value || '';
    
    if (/^[0-9+]*$/.test(inputValue)) {
      setErrorMessage('');
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name]: { ...prevValues[props.name], value: inputValue }
      }));
      
      if (props.onChange) props.onChange(inputValue, props.name);
      
    } else {
      setErrorMessage('Only numbers and + sign are allowed');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      setTimeout(() => {
        hideTooltip()
      }, 1000);
    }
  };

  const handleBlur = (e) => {
    if (errorMessage) {
      e.preventDefault(); // Prevents losing focus if there's an error
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);

      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }else if(e?.target?.value == '' || e?.target?.value == "+"){
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }
    else if(/^[0-9+]*$/.test(props.value)){
      hideTooltip()

    }
    else if(/^[0-9+]*$/.test(e?.target?.value)){
      hideTooltip()

    }else {
      // setErrorMessage('Only numbers and + sign are allowed');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }
    const inputValue = e?.target?.value || '';

    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: inputValue }
    }));

    if (props.onBlur) props.onBlur(inputValue, props.name);
  };

  const handleCreated = (e) => {
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: props.value || '' }
    }));

    if (props.onCreated) props.onCreated(e, props.name);
  };
  return (
    // <TooltipComponent
    //   content={errorMessage}
    //   position="TopCenter"
    //   openDelay={100}
    //   closeDelay={100}
    //   visible={!!errorMessage}
    // >
      <TextBoxComponent
        className='e-input'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        ref={textBoxRef}
        type={props.type ? props.type : 'text'}
        value={props.value || ''}
        created={(e) => handleCreated(e)}
        onBlur={(e) => handleBlur(e)}
        onChange={(e) => handleChange(e)}
        enabled={props?.enabled ? props.enabled : props?.isView ? !props.isView : true}
        multiline={props?.multiline || false}
      />
    // </TooltipComponent>
  );
};


// const DynamicCellInput = (props) => {
//   const [errorMessage, setErrorMessage] = useState('');
//   const textBoxRef = useRef(null);

//   const handleChange = (e) => {
//     const inputValue = e?.value || '';
    
//     if (/^[0-9+]*$/.test(inputValue)) {
//       setErrorMessage('');
//       props.setInputProps((prevValues) => ({
//         ...prevValues,
//         [props.name]: { ...prevValues[props.name], value: inputValue }
//       }));
      
//       if (props.onChange) props.onChange(inputValue, props.name);
//     } else {
//       setErrorMessage('Only numbers and + sign are allowed');
//     }
//   };

//   const handleBlur = (e) => {
//     if (errorMessage) {
//       e.preventDefault(); // Prevents losing focus if there's an error
//       textBoxRef.current.focus();
//       return;
//     }

//     const inputValue = e?.target?.value || '';

//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: { ...prevValues[props.name], value: inputValue }
//     }));

//     if (props.onBlur) props.onBlur(inputValue, props.name);
//   };

//   const handleCreated = (e) => {
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: { ...prevValues[props.name], value: props.value || '' }
//     }));

//     if (props.onCreated) props.onCreated(e, props.name);
//   };

//   return (
//     <TooltipComponent
//   content={<span style={{ color: 'red' }}>{errorMessage}</span>}
//   target={`#${props.name}`}
//   position="TopCenter"
//   openDelay={100}
//   closeDelay={100}
//   visible={!!errorMessage}
// >
//   <TextBoxComponent
//     ref={textBoxRef}
//     className='e-input'
//     placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//     name={props.name}
//     id={props.name}
//     floatLabelType='Auto'
//     type={props.type ? props.type : 'text'}
//     value={props.value || ''}
//     created={(e) => handleCreated(e)}
//     onBlur={(e) => handleBlur(e)}
//     onChange={(e) => handleChange(e)}
//     enabled={props?.enabled !== false}
//     multiline={props?.multiline || false}
//   />
// </TooltipComponent>

//   );
// };

// export default DynamicCellInput;

// export default ;


const DynamicEmailInput = (props) => {
  const tooltipRef = useRef(null);
  
  const showTooltip = (target, message) => {
    if (tooltipRef.current) {
      tooltipRef.current.destroy(); // Destroy existing tooltip if any
    }
    tooltipRef.current = new TooltipComponent({
      content: `<span class="error-tooltip">${message}</span>`,
      position: 'TopCenter',
    });
    tooltipRef.current.appendTo(target);
    tooltipRef.current.open(target);
  };
  
  useEffect(()=>{
return(
  hideTooltip()
)
  },[])
  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close();
      tooltipRef.current.destroy();
      tooltipRef.current = null;
    }
  };

  const [errorMessage, setErrorMessage] = useState('');
  const refs = useRef({});

  if (!refs.current[props.name]) {
    refs.current[props.name] = React.createRef();
  }
  const textBoxRef = refs.current[props.name];

  const handleChange = (e) => {
    const inputValue = e?.value || '';
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailPattern.test(inputValue) || inputValue === '') {
      setErrorMessage('');
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name]: { ...prevValues[props.name], value: inputValue }
      }));

      if (props.onChange) props.onChange(inputValue, props.name);

    } else {
      setErrorMessage('Please Enter Valid Email Address');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      setTimeout(() => {
        hideTooltip()
      }, 1000);
    }
  };

  const handleBlur = (e) => {
    if (errorMessage) {
      e.preventDefault();
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    } else if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(props.value)) {
      hideTooltip();
    
    } else if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( e?.target?.value)) {
      hideTooltip();
    }else{
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }

    const inputValue = e?.target?.value || '';

    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: inputValue }
    }));

    if (props.onBlur) props.onBlur(inputValue, props.name);
  };

  const handleCreated = (e) => {
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: props.value || '' }
    }));

    if (props.onCreated) props.onCreated(e, props.name);
  };

  return (
    <TextBoxComponent
      className='e-input'
      placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
      name={props.name}
      id={props.name}
      floatLabelType='Auto'
      ref={textBoxRef}
      type='text'
      value={props.value || ''}
      created={(e) => handleCreated(e)}
      onBlur={(e) => handleBlur(e)}
      onChange={(e) => handleChange(e)}
      enabled={props?.enabled ? props.enabled :  props.isView ? !props.isView : true}
      multiline={props?.multiline || false}
    />
  );
};



const DynamicCheckBoxInput = (props) => {
  console.log(props)
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.checked == true ? 1 : 0 }
    }));
  };
  // const handleBlur = (e) => {
  //   console.log(e)
  //   props.setInputProps((prevValues) => ({
  //     ...prevValues,
  //     [props.name]: {...prevValues[props.name] ,value :e.target.value == 'on' ? true : false}
  //   }));
  // };
  
  
  return (
    <>
    <CheckBoxComponent
        className="e-input"
        label={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        floatLabelType="Auto"
        checked={props.value ==  true ? 1 : false}
        change={(e)=>(handleChange(e) , props.onChange ? props.onChange(e.checked == true ? 1:0, props.name) : null)}
        onBlur={(e)=>( console.log(e), props.onBlur ? props.onBlur(props.value , props.name) : null)}
        disabled={props?.enabled   == undefined ? false : !props?.enabled}     

            />
            <TextBoxComponent
              name={props.name}
              id={props.name}
              value={props.value}
              type='hidden'

            />
      
    </>
  );
};

const DynamicHiddenInput = (props) => {
  console.log(props)
  
  const handleCreated = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :props.value}
    }));
  };
  return (
    <>
      <TextBoxComponent
        className='e-input'
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        value={props.value}
        created={(e)=>( handleCreated(),props.onCreated ? props.onCreated(e, props.name) : null )}
        type='hidden'
        
        />
    </>
  );
};

const DynamicButtonInput = (props) => {
  // Define the styles object
  const styles = {
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  };

  // Log the props for debugging
  console.log(props);

  const handleClick = (e) =>{
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,isClicked :true ,enabled:false }
    }));
  }
  // Return the component structure
  return (
    <div style={styles}>
      <ButtonComponent
        className="e-input"
        name={props.name}
        type='button'
        disabled={props.enabled == 'undefined' ? false : !props.enabled }
        id={props.name}
        onBlur={(e) => (e.preventDefault(),props.onBlur ? props.onBlur(props.name) : null)}
        onClick={(e) => (e.preventDefault(), handleClick(e) , props.onClick ? props.onClick(props.name) : null)}
      >
        {props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
      </ButtonComponent>
    </div>
  );
};


const StructuredGenerate = ({ title , mainProps , Inputs }) => {
  console.log(Inputs)
  return (
    <div className='row'>
        <div  className={`col-sm-${12}  `} style={{textAlign:'center'}}>
            <h1 style={{padding:'4px'}}>{title}</h1>
            </div>
      {Inputs.map((res, index) => {
        console.log(res)
        let Input = res.Input;
      //   if(res.Input.name == "DynamicHiddenInput"){
      // // return(<Input {...res.Props} {...mainProps} />)
      // return(
      //   <div key={index} className={`col-sm-${res.ColumnSize  == undefined  ? 0 :   res.ColumnSize}`}>
      //       <Input {...res.Props} {...mainProps} />
      //     </div>
      // )
      //   }else{
      let generateColumnClasses = typeof res.Props.name === 'object' ?  `${res.Props.name.value}_Col_${res.ColumnSize  == undefined ? 4 :res.ColumnSize}` : `${res.Props.name}_Col_${res.ColumnSize  == undefined ? 4 :res.ColumnSize}` ;
     return  (
          <div key={index} className={`${generateColumnClasses} col-sm-${res.ColumnSize  == undefined ? 4 :res.ColumnSize}`}>
            <Input {...mainProps}  {...res.Props} />
          </div>

        )
      // }
      })}
    </div>
  );
};






const DynamicDialogInput = ({
  isVisible,
  onClose,
  header = "Alert",
  content, // Can be text or a React component
  showButtons = false,
  buttons = [],
}) => {
  return (
    <DialogComponent
      visible={isVisible}
      header={header}
      close={onClose ? onClose : null}
      showCloseIcon={true}
      // content={typeof content === 'string' ? content : null} // Only set content prop if it's a string
      content={content} // Only set content prop if it's a string
    >
      {/* Render content as a child if it's a component */}
      {typeof content !== 'string' && content}
      
      {/* Buttons */}
      {showButtons &&
        buttons.map((btn, index) => (
          <ButtonComponent
            key={index}
            onClick={btn.onClick}
            isPrimary={btn.isPrimary}


          >
            {btn.content}
          </ButtonComponent>
        ))}
    </DialogComponent>
  );
};



export {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicDateInput,
  DynamicNumericInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicDialogInput,
  DynamicEmailInput
};
